export default {
	Crud: {
		Create: "Create",
		Read: "Read",
		Update: "Update",
		Delete: "Delete",
		List: "List",
		Additionals: "Additionals",
		Modules: "Modules",
	},
	NotPermissionPage: {
		NotPermissions: "You do not have permission for this option!",
		NotPermissionsText: "Contact the platform administrator for permission.",
		NotPermissionPlatform: "You do not have permission to access this platform",
	},
	NotAuthorizedPage: {
		Title: "You're not authorized",
		Subtitle: "Please contact the administrator, if you want to access.",
		SubtitleDatarutas:
			"To be able to select visit points from dataroutes, you first need to log in to your account.",
		SubtitleResourceDatarutas:
			"To be able to select resources from dataroutes, you first need to log in to your account.",
		ButtonText: "Back to the Router.",
		LogOut: "Log out",
		CompanyOperatingRange: "The company operating dates are out of the allowed range.",
	},
	DefinesHowTheSelectedRoutesWill:
		"Defines how the selected routes will be scheduled in Datarutas. It can be Standard, with a starting point and a final destination without intermediate stops, or With Stop Points, where points of interest are included to visit before the destination for deliveries or pickups.",
	ListOfSchedules: "List of Schedules",
	SelectSchedule: " Select Schedule",
	ListSchedules: " List Schedules ",
	Manage: "Manage",
	IncludeDeposits: "Include deposits in the export",
	Standard: "Standard",
	WithWaypoints: "With waypoints",
	Waypoint: "Waypoint",
	In: "in",
	TypeOfSchedule: "Type of schedule",
	RouteId: "Route Id",
	FileName: "File name",
	OnlyAMaximumOf3VisitPoints:
		" Only a maximum of 3 visit points are allowed for the collection service. Delete any of the selected ones to continue.",
	ThereAreNoVisitPointsAvailable:
		"There are no visit points available for the pick-up service. Please add them first using the corresponding option at",
	Cost: "Cost",
	Points: "Points",
	LimitvsServiceConsumption: "Usage vs Limit",
	Last1Day: "Last 1 day",
	Last7Days: "Last 7 days",
	LastMonth: "Last month",
	ConsumptionPerService: "Consumption per service",
	Totalconsumption: "Total consumption",
	TotalSubscriptionMonthly: "By subscription monthly",
	RoutingService: "Routing",
	Matrix: "Matrix",
	MapMatching: "Map matching",
	Isochrones: "Isochrones",
	FieldsWithTheIndicatedIconsAreCompatible:
		"Fields with the indicated icons are compatible with certain routers. Make sure to fill in this information if you plan to use them",
	RoadNetworkWithSouthAmerican:
		"Road network with South American countries such as: Argentina, Bolivia, Brazil, Chile, Colombia, Ecuador, Guyana, Paraguay, Peru, Suriname, Uruguay and Venezuela.",
	ViewMeshesAndTheirStatus: "View meshes and their status",
	Pending: "Pending",
	Available: "Available",
	NotAvailable: "Not available",
	RepetitionsHaveBeenGeneratedCorrectly: "Repetitions have been generated correctly",
	DeleteAssignment: "Delete assignment",
	AddRepeatFormatAndTimeWindow: "Add repeat format and time window",
	ViewRepetitionFormatAndTimeWindow: "View repetition format and assigned time window",
	Generate: "Generate",
	GenerationOfRepetitions: "Generation of repetitions",
	RepeatFormat: "Repeat format",
	NoGroupAssigned: "No Group Assigned",
	GroupSearch: "Group",
	ExpandAll: "Expand All",
	CollapseEverything: "Collapse Everything",
	DurationRefersToTheTotalTimeTaken:
		"Duration refers to the total time taken to complete an activity or process from start to finish, expressed in hours. Simply put, it is the period of time that passes while a task is being performed. If you wish to express the duration in days, it should be converted to hours (for example, 1 day is equal to 24 hours).",
	WithoutOriginIdentification: "Without origin identification",
	IdentificationOfOrigin: "Identification of origin",
	IdentificationOfOriginText:
		"Field to group vehicles under the same origin ID, facilitating the generation of several routes for the same vehicle. This field is neither unique nor required, which means that there can be multiple vehicles with the same origin ID.",
	IdentificationOfOriginVisitPointText:
		"Field to group visit points under the same origin ID, facilitating the generation of several routes for the same visit point. This field is neither unique nor required, which means that there can be multiple visit points with the same origin ID.",
	ChooseOneOrMoreOfTheseObjectivesToCustomize:
		"You can choose one or more of these objectives to customize the optimization according to your business needs, ensuring maximum efficiency and improving logistics planning results.",
	BasicObjectives: "Basic objectives",
	OptimizationObjectives: "Optimization Objectives",
	SelectBasicOrAdvancedObjectives: "Select basic or advanced objectives for optimization",
	MinimizeUnassigned: "Minimize Unassigned",
	MinimizeCost: "Minimize Cost",
	MinimizeDistance: "Minimize Distance",
	MinimizeDuration: "Minimize Duration",
	MinimizeTourCount: "Minimize Tour Count",
	MaximizeTourCount: "Maximize Tour Count",
	MinimizeTravelDuration: "Minimize Travel Duration",
	MaximumDistance: "Maximum distance",
	MaximumDiameter: "Maximum diameter",
	MaximumDistanceClusterText:
		"Defines the maximum distance (in meters) between a pickup/delivery and its nearest neighbor in the cluster. If a pickup/delivery is at this distance from another pickup/delivery, the algorithm can consider these pickups/deliveries as part of the same cluster. The range of values available for this parameter is from 0 to 75",
	MaximumDiameterClusterText:
		"Maximum allowable distance between any two pickups/deliveries in the cluster, in meters. This ensures that the cluster does not become too large in diameter, even if the individual pickups/deliveries are close enough to each other. The range of values available for this parameter is 0 to 1000",
	ClusteredRouteParametersText:
		"In tour planning, grouping geographically close jobs into a single stop creates more efficient routes by reducing travel time and minimizing fuel consumption. Reduced driving time allows more jobs to be performed and can increase the number of jobs completed in a shift",
	ClusteredRouteParameters: "Clustered Route Parameters",
	NoRoutingParametersAssigned: "No routing parameters assigned",
	Meters: "Meters",
	Initial: "Initial",
	End: "End",
	Penalty: "Penalty",
	ByAnticipation: "By anticipation",
	ForTardiness: "For tardiness",
	TheStartDateMust: "The start date must be within the time window",
	TheEndDateMust: "The end date must be within the time window",
	TheStartTimeMust: "The start time must be within the time window",
	TheEndTimeMust: "The end time must be within the time window",
	OptimizationGroup: "Optimization group",
	ControlPanel: "Control panel",
	IfYouExitNowAndYouHaveUnsavedData:
		"If you exit now and you have unsaved data, you will lose all the progress you have made. Are you sure you want to continue?",
	NotSpecified: "Not specified",
	NoneOfTheAbove: "None of the above",
	ValidatingTheInformationProvided: "Validating the information provided...",
	LoadingVisitPoints: "Loading visit points",
	MaxSelectedResourcesReached: "Maximum resource selection reached",
	ValidateField: "The {n} field is required",
	ThereIsNoDataToDisplayPleaseTryToAddNewRecords: "There is no data to display. Please try to add new records",
	NoResultsWereFoundForYourSearch: "No results were found for your search",
	UserRecordWithId: "User record with id",
	NotFound: "not found",
	Or: "Or",
	AllowedFileExtensions: "Allowed file extensions",
	DropFile: "Largar ficheiro",
	RealTimeTrafficData: "Taking real-time traffic into account when calculating routes",
	RealTimeTrafficDataText:
		"This option allows the optimization to take into account current traffic conditions, such as road closures, accidents and heavy traffic",
	TheMaximumFileSelectionForVehiclesHasBeenReached: "The maximum file selection for vehicles has been reached",
	VisitingPointsWereSuccessfullyAdded: "Visiting points were successfully added",
	VehiclesWereSuccessfullyAdded: "Vehicles were successfully added",
	TheMaximumFileSelectionPickup: "The maximum file selection for the collection has been reached",
	TheMaximumFileSelectionDelivery: "The maximum file selection for the delivery service has been reached",
	PickupPoints: "Pickup points",
	DeliveryPoints: "Delivery points",
	AllowedVehicleFiles: "Allowed vehicle files",
	AllowedPickupfiles: "Allowed pickup files",
	AllowedDeliveryFiles: "Allowed delivery files",
	AddVehicleStatistics: "Add statistics",
	DeterminesPageStatistics: "Determines whether to add a page with general vehicle statistics",
	RestoringOrder: "Restoring order",
	SortAndSelectTheFieldsToBeExported:
		"Sort the fields by dragging and dropping, select all or some of them to be exporteds",
	ManageFields: "Manage Fields",
	VehiclesUpdatedCorrectly: "Vehicles updated correctly",
	VisitingPointsCorrectlyUpdated: "Visiting points correctly updated",
	UpdatingVisitPointsByUploadingFiles: "Updating visit points by uploading files",
	UpdatingVehiclesByFileUpload: "Updating vehicles by file upload",
	UserHasAFileUploadProcessInPlace:
		"Mr.User has a file upload process in place.¿are you sure you want to abandon it?",
	YouWishToLeaveEven: "¿You want to leave even if there are no visits to correct?",
	ToAssignAVisitPoint: "To assign a visit point, they must have a resource assigned to them",
	ToAssignAnActivity: "To assign an activity, they must have a resource assigned to them",
	ToAssignAnActivityOrVisitPoint:
		"To assign an activity or visit point, visits must have a resource assigned to them",
	Visit: "Visit",
	VisitsWithErrors: "Visits with errors ",
	SearchResourceBy: "Search resource by",
	SearchVisitPointBy: "Search visiting point by",
	Unlimited: "Unlimited",
	Identification: "Identification",
	EndDeposit: "Final Deposit",
	StartDeposit: "Initial Deposit",
	TeamsTable: "Teams",
	SkillsTable: "Skills",
	Capabilities: "Capabilities",
	SpecifyTheTypeOfServiceForTheSelectedVisitPoints: "Specify the type of service for the selected visit points",
	ApiKey: "Api key",
	RoutingNotification: "Routing",
	RoutingNotNotification: "Non-Routed",
	GoTo: "Go to",
	ViewMore: "View more",
	CopiedTextErrors: "Data copied to clipboard successfully",
	ErrorInCopying: "Error in copying",
	Errors: "Errors",
	Go: "Go",
	Default: "Default",
	Undo: "Undo",
	ClickHereToVerify: "Click here to check the routing status",
	Duplicate: "Duplicate",
	Label: "Label",
	Options: "Options",
	TypeLabel: "Type label",
	Basics: "Basics",
	ExportAll: "Export All",
	Return: "Return",
	AcceptsNumbersAndTheDashSign:
		"Please enter a valid format for the name keeping in mind that it only accepts numbers, letters and underscores",
	See: "See",
	DeliveryService: "Delivery service",
	PickUpService: "Pickup service",
	ShippingTypeDelivery: "Shipping type delivery",
	PickupShippingType: "Pickup Shipping Type",
	Selected: "Selected",
	RemoveSelection: "Remove selection",
	ClearSelection: "Clear selection",
	ShowSelected: "Show selected",
	AssignTheCapacitiesFileUploadRouting: "Assign the capacities that will be used for file upload routing",
	AssignTheCapacitiesOptimizationRouting: "Assigns the capacities that will be used for routing by optimization",
	CreationDate: "Creation date",
	Of: "of",
	For: "for",
	SearchSeparatedByCommas: "Search multiple results by entering data separated by commas",
	Apply: "Apply",
	DELIVERY: "Delivery",
	PICKUP: "Pickup",
	TypeOfService: "Type of service",
	SelectAdditionalField: "Select additional field",
	NoResultsFoundFor: "No results found for",
	NoResultsFound: "No results found",
	Filters: "Filters",
	NotAdditionalFields: "The object does not have additional fields",
	LocationInformation: "Location information",
	SeeDetailedInformation: "See detailed information",
	PlatformStart: "Platform start",
	Check: "Check",
	Value: "Value",
	TagValue: "Tag value",
	LabelHelp: "Name visible on the form",
	PropertyDefinition: "Property Definition",
	AdditionalFields: "Additional Fields",
	Priority: "Priority",
	SelectInitTime: "Select initial time",
	SelectEndTime: "Select end time",
	Refresh: "Refresh",
	SearchBy: "Search By",
	NoDataAvailable: "No data available",
	ErrorTitle: "An error occurred",
	ErrorMessage: "Um erro ocorreu. Por favor, tente novamente!",
	Minimize: "Minimize",
	Maximize: "Maximize",
	To: "to",
	ViewInPopup: "View in popup",
	LogOut: "Log out",
	Schedule: "Schedule",
	All: "All",
	Activities: "Activities",
	Address: "Address",
	AddedOn: "Added",
	Back: "Back",
	CurrentPosition: "Current position",
	Modules: "Modules",
	Configuration: "Configuration",
	Accept: "Accept",
	Cancel: "Cancel",
	Country: "Country",
	City: "City",
	Department: "Department",
	Province: "Province",
	Region: "Region",
	State: "State",
	Canton: "Canton",
	Municipality: "Municipality",
	District: "District",
	Commune: "Commune",
	Name: "Name",
	Description: "Description",
	Warning: "Warning",
	Information: "Information",
	GeneralInformation: "General information",
	Dashboard: "Dashboard",
	eCommerce: "eCommerce",
	Apps: "Apps",
	Todo: "Todo",
	Chat: "Chat",
	Email: "Email",
	Username: "Username",
	Calendar: "Calendar",
	Format: "Format",
	FullCalendar: "Full Calendar",
	SimpleCalendar: "Simple Calendar",
	Shop: "Shop",
	ItemDetails: "Item Details",
	Cart: "Cart",
	WishList: "Wish List",
	Checkout: "Checkout",
	UI: "UI",
	DataList: "Data List",
	ListView: "List View",
	ThumbView: "Thumb View",
	Grid: "Grid",
	Vuexy: "Vuexy",
	Vuesax: "Vuesax",
	Tailwind: "Tailwind",
	Colors: "Colors",
	Card: "Card",
	Basic: "Basic",
	Statistics: "Statistics",
	Analytics: "Analytics",
	CardActions: "Card Actions",
	CardColors: "Card Colors",
	Table: "Table",
	agGridTable: "agGrid Table",
	Components: "Components",
	Alert: "Alert",
	Avatar: "Avatar",
	Badge: "Badge",
	Breadcrumb: "Breadcrumb",
	Button: "Button",
	ButtonGroup: "Button Group",
	Chip: "Chip",
	Collapse: "Collapse",
	Dialogs: "Dialogs",
	Divider: "Divider",
	DropDown: "DropDown",
	List: "List",
	Loading: "Loading...",
	Navbar: "Navbar",
	Notifications: "Notifications",
	Notification: {
		MarKAllRead: "Mark all as read",
		NewNotifications1: "New",
		NewNotifications2: "Notifications",
		Notification: "Notification",
		Notifications: "Notifications",
		DeleteAllNotifications: "Delete all notifications",
		UPLOAD_FILE: "Notifications about upload file",
		DOWNLOAD_FILE: "Notifications about download file",
		CREATE_OPTIMIZATION: "Notifications of new optimization",
		EVENT: "Notifications about calendar",
		New: "New",
		NewNotification: "New Notifications",
		AppNotifications: "App Notifications",
		NEW_EVENT: "NEW EVENT",
		EVENT_NOT_ASSIGNED: "EVENT NOT ASSIGNED",
		RESCHEDULED_EVENT: "RESCHEDULED EVENT",
		EVENT_IN_PROCESS: "EVENT IN PROCESS",
		EVENT_ENDED: "EVENT ENDED",
		EVENT_CANCELLED: "VISIT CANCELLED",
		EVENT_ON_THE_WAY: "ON THE WAY TO VISIT",
		EVENT_DELAYED: "IN DELAY TO VISIT",
		FINALIZED: "PROCESS FINALIZED",
		LOADED: "FILE LOADED",
		PROCESS: "FILE IS IN PROCESS",
		ERRORINFILE: "ERROR IN FILE",
		DOWNLOAD_FINALIZED: "Download Finalized",
		PANIC_ALARM: "Panic Alarm",
		PanicAlarmText: "A panic alarm was reported by one of the resource on the field",
		CheckOut: "Check Out",
		UPLOAD_FILE_PV: "Upload file visit points",
		UPLOAD_FILE_OP: "Upload file optimizations",
		DONE_OP: "Otimização concluída",
		PROCESSINGOPTIMIZATION: "PROCESSING OPTIMIZATION",
		OPTIMIZATIONERROR: "OPTIMIZATION ERROR",
		NewNotificationGlobal: {
			Title: "New notifications of completed routes",
			Text: "You have new routes completed, see your notification panel",
		},
	},
	Pagination: "Pagination",
	Popup: "Popup",
	Progress: "Progress",
	Sidebar: "Sidebar",
	Slider: "Slider",
	Tabs: "Tabs",
	Tooltip: "Tooltip",
	Upload: "Upload",
	FormsAndTable: "Forms & Table",
	FormElements: "Form Elements",
	Select: "Select",
	SelectAll: "Select All",
	Submit: "Submit",
	Switch: "Switch",
	Checkbox: "Checkbox",
	Required: "Required",
	Radio: "Radio",
	Input: "Input",
	NumberInput: "Number Input",
	Textarea: "Textarea",
	FormLayouts: "Form Layouts",
	FormWizard: "Form Wizard",
	FormValidation: "Form Validation",
	FormInputGroup: "Form Input Group",
	Pages: "Pages",
	ItemsPerPages: "Items per pages",
	Authentication: "Authentication",
	Register: "Register",
	ForgotPassword: "Forgot Password",
	LockScreen: "Lock Screen",
	Miscellaneous: "Miscellaneous",
	ComingSoon: "Coming Soon",
	Success: "Success",
	Error: "Error",
	404: "404",
	500: "500",
	NotAuthorized: "Not Authorized",
	Maintenance: "Maintenance",
	Profile: "Profile",
	User: "User",
	View: "View",
	UserSettings: "User Settings",
	ListOfUsers: "List of users",
	CreateUser: "Create user",
	UpdateUser: "Update user",
	ViewUser: "View user",
	CompanySettings: "Company Settings",
	Invoice: "Invoice",
	FAQ: "FAQ",
	Search: "Search",
	KnowledgeBase: "Knowledge Base",
	ChartsAndMaps: "Charts & Maps",
	Charts: "Charts",
	ApexCharts: "Apex Charts",
	chartjs: "chartjs",
	echarts: "echarts",
	chartist: "chartist",
	GoogleMap: "Google Map",
	Extensions: "Extensions",
	QuillEditor: "Quill Editor",
	DragAndDrop: "Drag & Drop",
	Datepicker: "Datepicker",
	DatetimePicker: "Datetime Picker",
	AccessControl: "Access Control",
	I18n: "I18n",
	Languages: {
		Languages: "Languages",
		Language: "Language",
		Spanish: "Spanish",
		English: "English",
		Portuguese: "Portugues",
	},
	Carousel: "Carousel",
	Clipboard: "Clipboard",
	ContextMenu: "Context Menu",
	StarRatings: "Star Ratings",
	Autocomplete: "Autocomplete",
	Tree: "Tree",
	// "Import/Export": 'Import/Export',
	Import: "Import",
	Export: "Export",
	ExportSelected: "Export Selected",
	Others: "Others",
	MenuLevels: "Menu Levels",
	MenuLevel2p1: "Menu Level 2.1",
	MenuLevel2p2: "Menu Level 2.2",
	MenuLevel3p1: "Menu Level 3.1",
	MenuLevel3p2: "Menu Level 3.2",
	DisabledMenu: "Disabled Menu",
	Support: "Support",
	Documentation: "Documentation",
	RaiseSupport: "Raise Support",
	demoTitle: "Card Title",
	demoText:
		"Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.",
	// Map Module
	Map: "Map",
	// Company Module
	Company: "Company",
	CompanyFormTitleCreate: "Form to create a new company",
	CompanyFormTitleUpdate: "Form to update a company",
	NewCompany: "New Company",
	UpdateCompany: "Update Company",
	ListOfCompanies: "List of Companies",
	TitleConfirmCompanyCreate: "Created company",
	TextConfirmCompanyCreate: "The company was successfully created",
	TitleConfirmCompanyDelete: "Deleted company",
	TextConfirmCompanyDelete: "The selected company was successfully deleted",
	TitleConfirmCompanyUpdate: "Updated company",
	TextConfirmCompanyUpdate: "The selected company was successfully updated",
	DeleteCompany: "Are you sure to delete this company? Please accept to continue",
	Confirm: "Confirm",
	MissingFieldTitle: "Missing fields",
	MissingField: "Some fields are missing in the form",
	CompanyCreate: {
		CompanyName: "Company Name",
		Address: "Address",
		Phone: "Phone",
		Nit: "NIT",
		InitDate: "Init Date",
		EndDate: "End Date",
		ContactPerson: "Contact Person",
		Country: "Country",
		City: "City",
		Description: "Description",
		Create: "Create",
		CreateFirstResourceAlert:
			"Now it is necessary to create the first resource for the administration of the company. please fill out the form.",
	},
	CompanyModule: {
		Add: "Add new",
		ManagingCompanies: "Managing companies",
		MissingServiceTime: "Missing service time",
		Month: "Month",
		Year: "Year",
		Day: "Day",
		Months: "Months",
		Years: "Years",
		Days: "Days",
		nameRequired: "The field name is required",
		addressRequired: "The field address is required",
		phoneRequired: "The field phone is required",
		nitRequired: "The field company nit is required",
		date_initRequired: "The field date init is required",
		date_endRequired: "The field date end is required",
		contac_personsRequired: "The field contact persons is required",
		cityRequired: "The field city is required",
		countryRequired: "The field country is required",
		descriptionRequired: "The field description is required",
		InvalidFields: "Invalid Fields",
		ChechInfo: "Please check the information, if all right, click on the Save button to finish the process.",
		ViewCompanyList: "Click here to go to the list of companies",
		AdminResource: "Administrator Resource",
		AdminResourceSuccess: "Administrator resource was create successfully",
		AdminResourceError: "Administrator resource could not be created",
		AdminResourceFailed:
			"Something went wrong during the creation of the Administrator Resource. try to create it again from the companies list.",
		DateInitError: "The start date cannot be greater than the end date.",
		CompanyInformation: "Company Information",
		Summary: "Summary",
		Finish: "Finish",
		ActivateServiroutes: "Select the administrator resource for the activation of servoutes.",
		ActivateSitidadaText1: "It is necessary to activate SITIDATA for a correct functioning of the platform",
		ActivateSitidadaText2: "click here to add configuration.",
		RequiredConfig: "Required Configurations",
		EmailAlreadyExist: "There is already a registered user with this email.",
		ValidEmail: "Email valid",
		ReleationShip: "Relationship with visit points",
		Table: {
			Name: "Name",
			Nit: "Nit",
			City: "City",
			Address: "Address",
			Phone: "Phone",
			Actions: "Actions",
			TotalResources: "Resources",
			Configuration: "Configuration",
			Configurations: "Configurations",
		},
		Form: {
			ValidMessages: {
				Name: "The company name field is required",
				Address: "The address field is required",
				Phone: "The telephone field is required and should be numerical",
				Nit: "The nit field is required",
				InitDate: "The init date field is required",
				EndDate: "The end date field is required",
				ContactPerson: "The contact person field is required",
				Country: "The country field is required",
				City: "The city field is required",
			},
			Labels: {
				Create: "Create",
				Update: "Update",
				Cancel: "Cancel",
			},
		},
	},
	// Breaks Module
	Breaks: "Breaks",
	MinBreakDuration: "Minimum duration",
	SelectMinBreakDuration: "Select minimum duration",
	AddBreak: "Add break",
	ListOfBreaks: "List of Breaks",
	NewBreak: "New Break",
	TitleConfirmBreakCreate: "Break created",
	TextConfirmBreakCreate: "The break was created successfully",
	TitleConfirmBreakDelete: "Break Deleted",
	TextConfirmBreakDelete: "The selected break was successfully deleted",
	TitleConfirmBreakUpdate: "Break Updated",
	TextConfirmBreakUpdate: "The selected break was updated successfully",
	DeleteBreak: "Are you sure you want to delete the break?",
	CreateBreak: "Create Break",
	UpdateBreak: "Update Break",
	visualizeBreak: "visualize break",
	AssignedBreaks: "Assigned Breaks",
	NoAssignedBreaks: "No assigned breaks",
	AssignBreaksTooltip: "Load the list of available breaks to continue",
	DeleteAllBreaks: "Eliminate all breaks.",
	ThereAreCurrentlyNoBreaksAvailable:
		"There are currently no breaks available on the platform. Add a new one using the option",
	BreakNotFound: {
		Title: "Break not found",
		Text1: "Break record with id:",
		Text2: "not found.",
	},
	BreakTable: {
		Name: "Name",
		Description: "Description",
		StartHour: "Start Hour",
		EndHour: "End Hour",
		AssignResources: "Assigned Resources",
		Action: "Actions",
		Delete: "Delete",
		Add: "Add New",
	},
	BreaksHour: "The start time cannot be greater than or equal to the end time.",
	BreakForm: {
		ValidMessages: {
			Name: "The name field is required",
			InitHour: "The Init Hour field is required",
			EndHour: "The End Hour field is required",
			InitHourEmpty: "The Initial Hour can not be empty",
		},
		ErrorMessages: {
			Error: "Error",
			InitHourHeigh: "The initial hour can not be greater at the end hour",
			ValidInitHour: "The init hour cannot be greater than or equal the end hour.",
			ValidEndHour: "The end time cannot be less than or equal to the start time.",
			DateInitError: "The start date cannot be greater than the end date.",
			ValidMinBreakDuration: "The minimum break duration cannot exceed the total duration of the break period.",
		},
	},
	RemoveBreak: {
		Text1: "¿Are you sure you want to delete the break",
		Text2: "Please accept to continue.",
	},
	// Skills Module
	Skills: {
		Skill: "Skill",
		Skills: "Skills",
		AddSkill: "Add skill",
		ListOfSkills: "List Of Skills",
		NewSkill: "New Skill",
		AssignedSkills: "Assigned skills",
		AssignSkill: "Assign skill",
		AssignSkills: "Assign skills",
		AssigneSkillTooltip: "Load the list of available skills to continue with the assignment",
		NoAssignedSkills: "No skills assigned",
		TotalSkills: "Total skills",
		NoSkillsAssigned: "No skills assigned",
		LoadListOfVehiclesSkills: "Load list of vehicles to be assigned to skills",
		TherAreCurrentlyNoSkillsAvailable:
			"Atualmente, não existem competências disponíveis na plataforma. Adicione uma nova competência utilizando o botão",
		Table: {
			Name: "Name",
			Description: "Description",
			Identifier: "Identifier",
			Action: "Actions",
			Delete: "Delete",
			Add: "Add New",
		},
		Messages: {
			Delete: "Are you sure you delete the skill? Please accept to continue",
			TitleConfirmDelete: "Skill Removed",
			TextConfirmDelete: "The selected skill has been deleted.",
			TitleConfirmCreate: "Skill Created",
			TextConfirmCreate: "The skill was created successfully",
			TitleConfirmUpdate: "Updated Skill",
			TextConfirmUpdate: "Skill was successfully updated",
			DeleteAll: "He is sure to remove all abilities from the table?",
		},
		CreateSkill: "Create Skill",
		UpdateSkill: "Update Skill",
		Form: {
			ValidMessages: {
				Name: "The name field is required",
				Identifier: "The identifier field is required",
				Description: "The description field is required",
			},
		},
		DeleteSkill: {
			Text1: "Are you sure to remove the ability",
			Text2: "Please accept to continue.",
		},
	},
	// Capacity Module
	Capacity: {
		Capacity: "Capacity",
		Capabilities: "Capabilities",
		CapabilityList: "Capability list",
		NewCapacity: "New capacity",
		AddCapacity: "Add capacity",
		CreateCapacity: "Create capacity",
		UpdateCapacity: "Update Capacity",
		AssignedCapacities: "Assigned capacities",
		AssignCapacity: "Assign capacity",
		AssignCapabilities: "Assign capabilities",
		NoAssignedCapability: "No assigned capacities",
		AssigneCapacityTooltip: "Load the list of available capacities to continue with the assignment",
		TotalCapacities: "Total capacities",
		NoAssignedCapacities: "No assigned capacities",
		ThereAreCurrentlyNoCapabilitiesAvailable:
			"There are currently no capabilities available on the platform. Add a new one using the option",
		MassiveActionsCapacities:
			"This option allows you to massively update the values ​​of the demand and type of service fields in the list of capacities",
		Messages: {
			Delete: "Are you sure to remove the capacity? Please accept to continue",
			TitleConfirmDelete: "Removed Capacity",
			TextConfirmDelete: "The selected capacity has been removed.",
			TitleConfirmCreate: "Capacity Created",
			TextConfirmCreate: "Capacity was successfully created",
			TitleConfirmUpdate: "Upgraded Capacity",
			TextConfirmUpdate: "Capacity was updated successfully",
			DeleteAll: "Are you sure to remove all capabilities from the table?",
		},
		DeleteCapacity: {
			Text1: "Are you sure to remove the capacity",
			Text2: "Please accept to continue.",
		},
	},
	// Teams Module
	Teams: {
		Team: "Team",
		WithoutTeam: "Without Team",
		Teams: "Teams",
		AddTeam: "Add team",
		ListOfTeams: "List of Teams",
		NewTeam: "New Team",
		ThereAreCurrentlyNoWorkTeamsAvailable:
			"There are currently no work teams available on the platform. Add a new one using the option",
		Table: {
			Name: "Name",
			Description: "Description",
			Action: "Actions",
			Delete: "Delete",
			Add: "Add New",
		},
		Form: {
			Label: "Label",
			Name: "Name",
			Type: "Type",
			Add: "Add",
			ValidMessages: {
				Name: "The name field is required",
				Description: "The description field is required",
				AddProperty: "Complete the fields to add a new property",
			},
		},
		Messages: {
			TitleConfirmCreate: "Work team created.",
			TextConfirmCreate: "The Team was created successfully",
			TitleConfirmDelete: "Work Team Eliminated",
			TextConfirmDelete: "The selected Task Force was successfully eliminated",
			TitleConfirmUpdate: "Updated work team",
			TextConfirmUpdate: "The selected work team was successfully updated",
			TextDelete: "Are you sure to delete the Work Team? Please accept to continue.",
		},
		CreateTeam: "Create Team",
		UpdateTeam: "Update Team",
	},
	// Deposits Module
	Deposits: {
		Depot: "Deposits",
		Deposit: "Depot",
		AddDeposit: "Add deposit",
		ListOfDeposits: "List of Depostis",
		NewDeposit: "New Deposit",
		CreateDeposit: "Create Deposit",
		UpdateDeposit: "Update Deposit",
		NotFoundAddress: "The entered address was not found on the map, drag the marker to the desired address",
		Table: {
			Name: "Name",
			Description: "Description",
			Address: "Address",
			City: "City",
			Action: "Actions",
			Delete: "Delete",
			Add: "Add New",
		},
		Form: {
			Address: "Address",
			City: "City",
			CX: "Coordinate X",
			CY: "Coordinate Y",
			Latitude: "Latitude",
			Longitude: "Longitude",
			StartAtDeposit: "Start at Deposit",
			EndAtDeposit: "End at Deposit",
			EndDeposit: "Final Deposit",
			StartDeposit: "Initial Deposit",
			AddResource: "Add Resource",
			ValidMessages: {
				Name: "The name field is required",
				Description: "The description field is required",
				Country: "The country country is required",
				Department: "The department field is required",
				City: "The city field is required",
				Address: "The address field is required",
				InitHourHigher: "The initial time can not be greater at the end time",
				ConfirmationMessage: "Confirmation message",
				AddressNotGeoRef: "The address could not be georeferenced confirm your address",
				AddressNotGeoRefSitidata:
					"The address could not be georeferenced confirm your address and check if sitidata service is enable",
			},
			GeoRef: {
				Finded: "The georeferenceder found the following address for the new coordinates:",
				UseVisitPoint: "Do you want to use this address for the point of view?",
			},
		},
		Messages: {
			TitleConfirmCreate: "Deposit created.",
			TextConfirmCreate: "The Deposit was created successfully",
			TitleConfirmDelete: "Deposit Eliminated",
			TextConfirmDelete: "The selected Deposit was successfully eliminated",
			TitleConfirmUpdate: "Updated Deposit",
			TextConfirmUpdate: "The selected Deposit team was successfully updated",
			TextDelete: "Are you sure to delete the Deposit? Please accept to continue.",
			TextResources:
				"Remember: If you assign a resource to this deposit, and it was previously assigned to another, the previous deposit will be replaced by the current one.",
			DepositNotFound: "Deposit not found",
			CountriesError: "Countries were not obtained",
			DepartmentsError: "Departments were not obtained",
			CitiesError: "Cities were not obtained",
			CityAndDirectionRequired: "City and address fields are required for georeference",
		},
		Labels: {
			StartInDeposit: "Start at Deposit?",
			EndInDeposit: "End at Deposit?",
			Resource: "Resource",
			Yes: "Yes",
		},
		Options: {
			StartAtDeposit: "Start at Deposit",
			EndAtDeposit: "End at Deposit",
			NotStartAtDeposit: "Not start at Deposit",
			NotEndAtDeposit: "Not end at Deposit",
		},
	},
	// Status
	Status: {
		Title: "Status",
		ListOfStatus: "List of Status",
		CreateStatus: "Create Status",
		UpdateStatus: "Update Status",
		AddNew: "Add New",
		Create: "Create",
		Form: {
			ValidMessages: {
				Name: "The name field is required",
			},
		},
		Messages: {
			TitleConfirmCreate: "Created.",
			TextConfirmCreate: "The status was created successfully",
			TitleConfirmDelete: "Removed",
			TextConfirmDelete: "The selected status was successfully removed",
			TitleConfirmUpdate: "Updated",
			TextConfirmUpdate: "The selected status was successfully updated",
			TextDelete: "Are you sure to delete the selected status? Please accept to continue.",
		},
	},
	// Type Config
	TypeConfig: {
		Title: "Type Config",
		Create: "Create New Config Type",
		Update: "Update Config Type",
		List: "List of Config Type",
		New: "New Type Configuration",
		AddNew: "Add New",
		Form: {
			Name: "Name",
			Status: "Status",
			Field: "Field",
			ValidMessages: {
				Name: "The name field is required",
				Status: "The status field is required",
				Complete: "Complete the name of the field",
			},
		},
		Messages: {
			TitleConfirmCreate: "Config Type created.",
			TextConfirmCreate: "The Config Type was created successfully",
			TitleConfirmDelete: "Config Type Eliminated",
			TextConfirmDelete: "The selected Config Type was successfully eliminated",
			TitleConfirmUpdate: "Updated Config Type",
			TextConfirmUpdate: "The selected Config Type team was successfully updated",
			TextDelete: "Are you sure to delete the Config Type? Please accept to continue.",
			OneElement: "You should add at least 1 property",
		},
	},
	//Tipology Module
	Tipology: "Tipology",
	TextConfirmTipologyCreate: "Tipology was create successfully",
	TextConfirmTipologyUpdate: "Tipology was update successfully",
	TextConfirmTipologyDelete: "Tipology was delete successfully",
	TitleConfirmTipologyCreate: "Created tipology",
	TitleConfirmTipologyUpdate: "Updated tipology",
	TitleConfirmTipologyDelete: "Deleted tipology",
	TextDeleteTipology: "Are you sure to delete the tipology ",
	TextAccepContinue: "Please accept to continue",
	Save: "Save",
	Edit: "Edit",
	Remove: "Remove",
	Add: "Add",
	// Category Module
	Category: "Category",
	NewCategory: "New Category",
	ListOfCategories: "List of Categories",
	TitleConfirmCategoryCreate: "Created object",
	TitleConfirmCategoryUpdate: "Updated object",
	TitleConfirmCategoryDelete: "Deleted object",
	TextConfirmCategoryCreate: "The new object was created successfully!",
	TextConfirmCategoryUpdate: "The object was updated successfully!",
	TextConfirmCategoryDelete: "The object was deleted successfully!",
	// Resources Module
	Resource: "Resource",
	Resources: "Resources",
	CreateResource: "Create resource",
	CreateFirstResource: "Create First Resource",
	CreateObject: "Create Object",
	ViewResource: "See Resource",
	ResourceModule: {
		TotalCost: "Total cost",
		TotalResourcesSelected: "Total resources selected",
		UpdateResource: "Update resource",
		UserNotFound: "User not found",
		NewResource: "Add Resource",
		SelectTeamsResource: "Select the teams of the resource",
		AssignedResources: "Assigned Resources",
		AssigResources: "Assign Resources",
		LoadListResources: "Load list of resources to assign to the capacities.",
		DeleteResource: "Delete Resource",
		DeleteResources: "Delete Resources",
		DeleteAllResources: "Delete All Resources",
		NotResources: "No resources assigned",
		ResourceList: "Resource List",
		SelectedResourcesFrom: "Selected resources from",
		ResourceSelectedFrom: "Resource selected from",
		ShowOnlySelectedResources: "Show only selected resources",
		YouWantTheSelectedResourcesToBeRemoved:
			"you want the selected resources to be removed from the resource module at the end of the import process",
		ResourceSelectionwillBecomeObsolete:
			"Resource selection will become obsolete. We invite you to export your executive and supervisory resources to the new vehicle module",
		MassiveActionsResource:
			"This option allows you to bulk update the demand field value on the selected resources",
		BasicInfoForm: {
			ValidMessages: {
				Username: "The username field is required",
				Identification: "The ID field is required",
				Name: "The name field is required",
				LastName: "The last name field is required",
				Role: "The role field is required",
				Status: "The status field is required",
				Email: "The email field is required and it must be valid",
				Country: "The country field is required",
				Departament: "The department field is required",
				Address: "The address field is required",
				City: "The city field is required",
			},
			Messages: {
				NoCity: "The city can not be empty.",
				NoAddress: "The address can not be empty.",
				SpecifyCity: "Specify the city for better accuracy.",
				AllFieldsRequired: "All fields are required.",
				ClickGeoReference: "You must click on the 'Georeference' button",
			},
		},
		CapacitiesActivities: {
			SubtitleActivities: "Assign the resources working hours, its start time, and its end time for the day.",
			SubtitleCapacities: "Assign the capabilities of the current resource.",
			Units: {
				Area: "Area",
				Volume: "Volume",
				Kilos: "Kilos",
				Weight: "Weight",
				Free: "Free",
			},
			CapacityValidMessages: {
				Title: "Capacity",
				Number: "The value of the capacity must be of floating value",
				Empty: "Enter the ability name",
				ScoreEmpty: "Enter the decimal value for capacity",
				ThreeCapacities: "You can only enter a maximum of 3 capabilities",
				SelectCapacity: "Select a capacity",
				EnterAmount: "Enter the quantity",
			},
		},
		Skills: {
			Subtitle: "Select Resource skills",
		},
		Breaks: {
			Subtitle: "Select Resource breaks",
		},
		Deposits: {
			Subtitle:
				"Please select a deposit for initial and end route, for the current resource from the both list above.",
			InitialResourceDepot: "Initial resource deposit:",
			FinalResourceDepot: "Final resource deposit:",
		},
		AdditionalFields: {
			ValidCompleteValues: "Enter all values in the fields",
		},
		Create: {
			FinalHour: "End Hour",
			ValidEndHour: "The final hour field is required",
			InitialHour: "Initial Hour",
			ValidInitialHour: "The initial hour field is required",
			Capacity: "Unit",
			CapacityValue: "Amount",
			KeyValue: "Key Value",
			Label: "Label",
			LabelMessage: "Informative label for the user",
			Type: "Type",
			FieldValue: "Value",
			SelectResource: "Select Resources",
			Add: "Add",
			Save: "Save",
			Clear: "Clear",
			Action: "Action",
			Delete: "Delete",
			Next: "Next",
			Back: "Back",
			SuccessText: "Resource Created",
			Import: "Import",
			ImportResources: "Import Resources from dataRutas",
			DataRutasResourceSelected: "Selected Resource:",
			ResourcesNotAvailable: "Resources not available at the moment",
			MaxServiceTime: "Max Service Time",
			MaxTravelDistance: "Max Travel Distance",
			Previous: "Previous",
		},
		Edit: {
			PageTitle: "Edit Resource",
			Title: "Edit Information",
			Table: {
				Permissions: "Permissions",
				Module: "Module",
				Read: "Read",
				Write: "Write",
				Create: "Create",
				Delete: "Delete",
			},
			Save: "Save Changes",
			Success: {
				Title: "Success",
				Text: "Updated Resource",
			},
			Error: {
				Title: "Error",
				Text: "Step 1 and 2 are required.",
				Text2: "It is mandatory to configure the time window of the resource.",
				Email: "Email already registered.",
				Id: "Identification already registered.",
				Username: "Username already registered.",
				Typology: "Please select the typology",
				All: "All fields are required",
				InitEndHoursReq: "Init and End hours are required.",
			},
		},
		Table: {
			Id: "Id",
			Username: "User",
			Name: "Name",
			Lastname: "Lastname",
			Email: "Email",
			Role: "Role",
			Status: "Status",
			Actions: "Actions",
			Identification: "Identification",
			Address: "Address",
			City: "City",
			Department: "Department",
			Delete: "Delete",
			Search: "Search...",
			AdditionalFields: "Additional Fields",
			Team: "Work Team",
			Optimizer: "Optimizer",
			Company: "Company",
			Type: "Type",
			Errors: {
				ConsultResources: "Resources were not obtained",
				ConsultResource: "Resource were not obtained",
				Delete: "The resource was not removed",
				ConsultSkills: "Getting the skills",
				ConsultTeams: "Getting the teams",
				ConsultBreaks: "Getting the breaks",
				ConsultDepots: "Getting the depots",
			},
		},
		Messages: {
			TitleConfirmDelete: "Confirm delete",
			TitleDeleted: "Resource deleted",
			Delete: "Are you sure to delete the resource: ",
			Deleted: "The resource was successfully deleted.",
			AddProperties: {
				Success: {
					Title: "Aggregate field",
					Text: "The new field was added successfully",
				},
				Error: {
					Title: "Error adding",
					Text1: "It is not possible to add if the fields and label are empty",
					Text2: "You can not add this field, because one already exists with the same name",
				},
			},
			RemoveProperties: {
				Title: "Deleted field",
				Text: "The selected field has been successfully removed",
			},
		},
		Title: {
			SkillsOptional: "Skills (Optional)",
			TeamsOptional: "Teams (Optional)",
			BreaksOptional: "Breaks (Optional)",
		},
		Costs: {
			Subtitle: "Assign the costs variables to the current resource.",
			"Fixed cost": "Fixed cost",
			"Cost per kilometer of the vehicle route": "Cost per kilometer of the route",
			"Cost per hour of the vehicle route": "Cost per hour of the vehicle route",
			"Cost per traveled hour of the vehicle route": "Cost per traveled hour of the route",
			KilometeOfTravel: "Kilometer travel",
			Fixed: "Fixed",
			RoutingTime: "Route time",
			TimeTraveled: "Time traveled",
		},
	},
	Routing: {
		Car: "Car",
		Walker: "Walker",
		Walking: "walking",
		Bicycle: "Bicycle",
		Motorcycle: "Motorcycle",
		Truck: "Truck",
		Bus: "Bus",
		Scooter: "Scooter",
		MaxDuration: "Max duration (min)",
		MaxDistanceSpeed: "Max speed (km/h)",
		YearsAgo: "{n} years ago ",
		YearAgo: "1 year ago",
		DaysAgo: "{n} days ago",
		DayAgo: "1 day ago",
		HoursAgo: "{n} hours ago ",
		HourAgo: "1 hour ago",
		MinutesAgo: "{n} minutes ago ",
		MinuteAgo: "1 minute ago",
		SecondsAgo: "{n} seconds ago",
		SecondAgo: "Just Now",
		ROUTING_DONE: "Routing completed",
		ROUTING_ERROR: "Error with the routing",
		ROUTING_PROCESS: "Routing in process",
		Resource: "Resource",
		Routing: "Route visit points",
		Point: "Point",
		DistanceRoute: "Distance",
		MinimumRouteTime: "Route time",
		Typology: "Typology",
		SelectedColumns: "Columns Selected",
		ModuleNotEnabled: "Module not enabled",
		SelectTypeRouter: "Select the routing mode",
		VisitPointData: "If the file is loaded with Datarutas visit points, please activate the following option.",
		FromMapTitle: "Select a point on the map by clicking on the desired position or by dragging the marker",
		FromMapAlert: "Select a point on the map by clicking on the desired position",
		FromMap: "Enables the function of being able to select a point from the map by clicking where you want",
		CreateRouting: "Create routing",
		Optimizer: "Optimizer",
		TypesOfOptimization: "Types of optimization",
		ListOfRoutingTypes: "List of routing types",
		FileUploadRouting: {
			Title: "File upload routing",
			Subtitle:
				"Allows you to select a routing mode (Logistic Routing, Basic Routing, Selection Routing, Datarutas Routing) and then load a file with a vehicle routing problem to get the best route.",
		},
		FileUploadOptimization: {
			Title: "File upload optimization",
			Subtitle:
				"Allows you to select a type of routing (Logistic Routing, Basic Routing, Selection Routing, Datarutas Routing)",
		},
		CreateNewOptimization: {
			Title: "Create new optimization",
			Subtitle:
				"It allows to create a new optimization with points of visits and resources registered from the platform.",
		},
		DatarutasRouting: {
			Title: "Datarutas Routing",
			Subtitle: "The Datarutas routing will allow you to create basic routings with Datarutas' visit points.",
		},
		LogisticRouting: {
			Title: "Logistic Routing",
			Subtitle:
				"The logistics routing will allow you upload a file with clients to visit and vehicles available considering time windows and delivery capacities for the best route.",
		},
		BasicRouting: {
			Title: "Basic Routing",
			Subtitle:
				"The basic routing gives us an optimal route according to the closeness of the points through the Google Maps API, with a point-to-point sequencing.",
		},
		RoutingBySelection: {
			Title: "Rounting by Selection",
			Subtitle:
				"The routing by selection will allow you to make a strategic selection (concentration of points on the map) of visiting points from the map, previously obtained and located from a loading file, a source of data of databilities or previously charged files.",
		},
		RoutingHistory: {
			Title: "Routing History",
			Subtitle: "The routing history, allows to visualize the routeos performed by the user.",
			SubtitleView: "View routes uploaded by the user.",
			NoResults: "No results were found, to create your first route click",
			Here: "here",
			Unauthorized: "Unauthorized",
			UnauthorizedRouting: "No valid credentials for the router.",
			ErrorRoutingProcess: "Something was wrong  during the routing process.",
			SuccessRoutingProcess: "Routing process completed successfully.",
			RoutesEmpty: "Data about routes not found.",
		},
		CreateVisitPoint: {
			ServiceTime: "Service Time",
			ValidServiceTime: "The service time field is required",
			ReviewVisitPoints: "Review Visit Points",
			ConfigureActivityForAll: "Configure Activity for All",
			ConfigureActivityForAllText: "You need to set an activity for all records to continue.",
			ExportDataRutasVisitPoint: "Export DataRutas Visiting Points",
			BulkAssign: "Bulk Assign",
			DragFiles: "Drag your files here or click in this area",
			DeleteAsk: "Are you sure, you want delete the file?",
			Errors: {
				ValidateManually: "Validate manually",
				FindLagOptimizeAgain: "We found some lag, please hit optimize again",
				SelectActivity: "Select an activity",
				DeleteRoute: "The route has not been removed",
				ErrorImporting: "Error at importing information",
			},
			Success: {
				VisitPointValidate: "Visit Point validate",
				Proccesing: "Proccesing",
				NotifyRouteWillBeRouted: "You will be notified when the file is completely routed",
				DeleteRoute: "The route has been successfully removed",
			},
		},
		Buttons: {
			Process: "Process File",
			Next: "Next",
			Optimize: "Optimize",
			Reoptimize: "Reoptimize",
			SeeRoute: "See Route",
			Validate: "Validate",
			OtherFields: "Add to others fields",
			AddVisitPoint: "Add Visit Point",
			EditVisitPoint: "Edit",
			NextResources: "Next, Select Resources",
			ExportRoute: "Export route",
			DownloadRoute: "Download route",
			Downloading: "Downloading...",
			SeeAllRoutes: "See Routes",
			Schedule: "Schedule",
			DeleteRoute: "Delete route",
			ReOptimizeRoutes: "Reoptimize routes",
			Discard: "Discard ",
		},
		Table: {
			Type: "Type",
			Name: "Name",
			AddedOn: "Added On",
			Action: "Action",
			Actions: "Actions",
			Longitude: "Longitude",
			Latitude: "Latitude",
			EstimatedTimeArrival: "Estimated Time Arrival",
			WaitingTime: "Waiting time",
			DistanceFromPrevious: "Distance from previous (km)",
			TotalDistanceTraveled: "Total distance traveled (km)",
			EstimatedStartTask: "Estimated start task",
			EstimatedDepartureTime: "Estimated Departure Time",
			TimeService: "Service Time",
			TimeWindowInit: "Init Time",
			TimeWindowEnd: "End Time",
			Cx: "Latitude",
			Cy: "Longitude",
			Demand: "Demand",
			InitHour: "Init Hour",
			EndHour: "End Hour",
			Identification: "Identification",
			Skills: "Skills",
			Row: "Excel Row",
			Column: "Excel Column",
			Error: "Error",
			Break: "Break",
			Depot: "Depot",
			Pickup: "Pickup",
			Delivery: "Delivery",
		},
		Title: {
			ResourceList: "Resources List",
			VisitPointsList: "Visit Points List",
			SelectFormat: "Select format",
			Close: "Close",
			MatchColumn: "Match Column",
			TableExample: "Uploaded File Data Example",
			TableExampleText: "Below is a preview of the data found in the uploaded file",
			ProcessVisitPoints: "Process Visit Points",
			EditVisitPoint: "Edit Visit Point",
			VisitPoints: "Visit points",
			VisitPointsDatarutas: "Datarutas Visit Points",
			VisitPointsLocations: "Visit Points Locations",
			Resources: "Resources",
			OptimizeByTeam: "Filter by team",
			SelectResource: "Select the resources to export the route",
			Errors: "Errors Found",
			UploadVisitpoints: "Upload visit points",
			UploadVisitpointsList: "List uploaded files",
			ExportFromDataRutas: "Import visit points from DataRutas",
			RoutingHistory: "Routing History",
			Schedule: "Schedule",
			RoutingMode: "Select routing type",
			RoutingType: "Selecione o tipo de roteamento",
			Basic: "Basic",
			Logistic: "Logistics",
			Selection: "Selection",
			AssignBulkActivity: "Assign Bulk Activity",
			AssignActivity: "Assign activity to all of checked visit points.",
		},
		Map: {
			SeeMap: "See Map",
			ShowMap: "Show Map",
			HideMap: "Hide Map",
			MapAppearance: "Map Appearance",
			Types: "Map Type",
			Styles: "Map Style",
			ClickToDownload: "Click to download",
			Coordinates: "Coordinates",
			Georeference: "Georeference",
			Latitude: "Latitude",
			Longitude: "Longitude",
			GeoCoordinates: "Geographical coordinates",
			GeoreferencingByAddress:
				"Georeferencing by address has been enabled to find the coordinates and locate them on the map, you must",
			DiscardTheChanges: "handle or to discard the changes click",
			CellAutoWith: "Cell Auto Width",
			ExportRoute: {
				Error: "The route could not be exported",
				Success: "Route exported successfully",
				DownloadError: "Error downloading file. Please try again.",
			},
			Schedule: {
				OptionalDate: "Date",
				ClickToSchedule: "Click to schedule",
				Success: "Schedule request sent, to verify use the Datarutas calendar",
				Error: "An error occurred and your schedule was not sent",
				ErrorOptimization:
					"An error occurred while scheduling the visits, check the option to correct it and reschedule",
				FoundErrors: "Some visits cannot be scheduled.",
				NotScheduledVisits: "Not scheduled visits",
				ErrorResource:
					"An error occurred scheduling the visits. The highlighted resources were not found in Datarutas.",
				SameDate:
					"Trying to schedule for the same day may cause some visits not to be scheduled, this is because DATARUTAS does not allow visits to be scheduled for less than the current date and time.",
				InitHourError: "The start time cannot be less than the current time",
				VisitpointError: "The selected visit point is not assigned to the current resource",
				ResourceActivityError: "The selected activity is not assigned to the current resource",
				WeAreGeneratingTheSchedule: "We are generating the schedule. Please wait...",
			},
			VisitPoints: {
				Drop: "Drop Visit Point",
				Dropped: "Not routed visit point",
				Identifier: "Identifier",
				TimeArrival: "Time to arrival",
				Deposit: "Deposit",
			},
			DeleteRoute: {
				DeleteRouteAsk: "Are you sure, you want delete the current route?",
				Success: "Route removed successfully",
			},
		},
		RouteResult: {
			Title: "Route Result",
			ResourcesRouted: "Resources Routed",
			ResourcesNotRouted: "Resources Not Routed",
			RoutesTime: "Total minimum time all routes",
			TotalDistance: "Total Distance",
			VisitPointsRouted: "Visit Points Routed",
			VisitPointsNotRouted: "Visit Points Not Routed",
			TotalResources: "Total Resources",
			TotalVisitPoints: "Total Visit Points",
			TotalRoutings: "Total Routings",
			DrivingTimme: "Driving Time",
			Load: "Load",
			Capacities: "Capacities",
			LoadCapacity: "Load Capacidad",
			SeeRoutes: "See Routes",
			HideRoutes: "Hide Routes",
			HideRoute: "Hide route",
			ChangeColorRoute: "Change color to the route",
			Routes: "Routes",
			RespectPlannedRoute:
				"This selected option allows the router to honor the planned route or else it will search for a new route during reoptimization",
		},
		Messages: {
			MatchColumnSelectionRoutingP2Tooltip: "Map the columns of your file to the required fields",
			upload_placeholder: "Drag your files here or click to add a file",
			MatchColumn:
				"Keys and values equivalent to the column names given in the file to be processed, for routing.",
			MatchColumnSelectionRouting:
				"Assignment of equivalences between columns found in the file and the properties required by the routing process.",
			MatchColumnSelectionRoutingP2:
				"Select next to each column name found in the file the value corresponding to the equivalence of the load.",
			MatchColumnSelectionRoutingP3:
				"Through the option add of the list, we can add the columns as additional values to the result of the routing process, the rest of the columns will be omitted.",
			MatchColumnSelectionRoutingP4:
				"Once the assignment is finished, click on the save button to continue with the selection on the map.",
			MatchColumnSelectionRoutingError: "The following equivalences were missing to be assigned: ",
			MatchColumnSelectionRoutingErrorTitle: "Error Equivalences",
			FileWithErrorsRoutingErrorTitle: "File Has Errors",
			MatchColumnSelectionRoutingErrorEquivalents: "It is necessary to assign the equivalences of the columns",
			SelectedColumns:
				"Column names that you want to keep and that appear in the routing response, the rest of the fields will be omitted.",
			ErrorMsg: "Please fix this errors on your excel file and try to upload it again.",
			ErrorMsg2: "Please fix the errors previously mentioned and try to upload the file again.",
			AlertRoutingHistory:
				'Remember that you can re-optimize a previously loaded route, using the "optimize" function and selecting new resources.',
			AlertProccessing: "We are working to optimize your routing, we will notify you when it is completed.",
			SelectSchedule: "Select your resources to schedule",
			DataRutasVisitPointsSelect:
				"This is your list of visit points in DataRutas, to route using these points, select them and choose a route type",
			AssignEquivalents: "Asignación Equivalencias De Columnas",
			Required: "Required",
			InformationFound: "Información found",
			ErrorsFound: "Errors found during the upload information process",
			ErrorsNotFound: "No errors found during the information upload process",
			ValidatorRequiredProperty: "Is not a valid value",
			AlreadyRegistered: "Already registered",
			DateLessThanCurrentDate: "Date less than current date",
			NotRegistered: "Not registered",
			ValidatorAdditionalProperties: "Additional properties are not allowed, delete its",
			TooShortProperties: "Property value is empty or content is too short",
			TimeDataFormat: "Hour format is not valid, the correct format time should be similar to HH:mm:ss",
			IsNotInteger: "Is not a valid integer value",
			InitHourWindowGreater: "The start time cannot be greater than or equal to the end time",
			ValidDemands: "Demands names allowed on the platform",
			DemandsInFile: "Names of demands sent (File headers)",
			InvalidDemands: "Invalid demands",
			InvalidDemandsNames:
				"The names of the demands in the file (Header Name) do not match any demand names allowed on the platform. Please modify the header names taking into account the names allowed by the platform",
		},
		AssignColumns: {
			Text1: "The",
			Text2: "field is required",
		},
		ValidateMessages: {
			Text: "Are you sure to discard the changes made?",
			Yes: "Yes",
			Not: "Not",
		},
		HistoricalReOptimizationText:
			"The re-optimization is running in the background and the platform will notify you about its status via the notification module",
		ValidateChangesReOptimize:
			"You have made changes to reoptimize the route. Are you sure you want to exit and discard the changes?",
	},
	// Divipola
	Divipola: {
		Country: "Country",
		Department: "Department",
		City: "City",
		Address: "Address",
		GeoSearch: "Geo Search",
		GeoAgain: "Georeference Again",
		GeoSub: "Georeference and locate the entered address on the map.",
	},
	UploadFiles: {
		UploadFiles: "Upload Files",
		File: "File",
		UploadFile: "Upload File",
		UploadSuccess: "Upload Success",
		UploadSuccessMessage: "The file was uploaded successfully.",
		UploadingFile: "Uploading file...",
		ProcessingFile: "Processing file",
		Progress: "Progress",
		Uploading: "Uploading",
		Complete: "Complete",
		UploadSuccessful: "Upload successful!",
		RedirectingToMapping: "Redirecting to column mapping...",
		PleaseWait: "Please wait...",
		UploadError: "Upload Error",
		Mapping: "Mapping",
		Required: "Required",
		Optional: "Optional",
		RequiredFields: "Required fields",
		SmartSuggestions: "Suggestions",
		ClickToSelect: "Click to assign a suggestion",
		NoColumnsAvailable: "No columns available",
		Columns: "Columns",
		Records: "Records",
		UploadErrorMessage:
			"An error occurred while uploading the file, please check if the file has the basic structure or download the example files",
		UploadType: "Upload Type",
		UploadTypeSelectToltip: "Upload type defines the type of file upload.",
		UploadTypeObjectToltip: "Defines the structure of the file to load taking into account its additional fields.",
		FormatFile:
			"Select a routing file to start the process, only the following formats are allowed: excel (.xlsx), json, csv and xml",
		SelectFile: "Select File",
		UploadFileDragAndDrop: "Drag and drop a file here",
		UploadSuccessTextAlert:
			"The file was uploaded successfully, please wait until the system will notify you about when the process finished.",
		FileReadyToBeUploaded: "File ready to be uploaded.",
		Details: "Details",
		Size: "Size",
		TypeInvalid: "Invalid file type",
		TypeInvalidText: "The type of the selected file is not valid.Please enter an Excel file.",
		UploadFileText: "Upload Visit Points",
		Format: "Format",
		Formats: "Formats",
		Download: "Download",
		UploadTypeCountryTooltip: "Select the country where the visiting points to upload will be georeferenced.",
		DownloadFailed: "Download failed",
		DownloadFailedText: "Download failed, file not found or was removed from the server",
		FileNotFound: "File not found",
		DownloadFormat: "Download basic file",
		DownloadFormatText:
			"Download a base or template file in the selected format that contains the required structure for the selected upload type",
		InvalidFormatFile: "Invalid format file",
		ListOfUploadedFiles: "List of uploaded files",
		TitleConfirmDelete: "File deleted",
		InvalidFormatFileText:
			"Please select a file with the correct format to continue with the upload only .xlsx, .xls, .csv, .txt, .json or .xml files are allowed",
		LoadMassiveAssignmentUploadFileError: "The file does not have a valid format to upload the information",
		DeleteUploadFile: {
			Text1: "Are you sure you want to delete the file",
			Text2: "Please accept to continue.",
		},
	},
	//
	Objects: "Objects",
	NewObject: "New object",
	ListOfObjects: "List of objects",
	TooltipSchemas: `El esquema define las propiedades mínimas que pueden tener objetos los dependiendo del tipo seleccionado.`,
	Config: "Config",
	// VisitPoint
	VisitPoint: "Visit Point",
	CreateVisitPoint: "Router",
	// Activity
	Activity: "Activity",
	ActivityList: "Activity List",
	CreateActivity: "Create Activity",
	TitleConfirmActivityCreate: "Created activity",
	TextConfirmActivityCreate: "The activity was successfully created",
	TitleConfirmActivityDelete: "Deleted activity",
	TextConfirmActivityDelete: "The selected activity was successfully deleted",
	TitleConfirmActivityUpdate: "Updated activity",
	TextConfirmActivityUpdate: "The selected activity was successfully updated",
	DeleteActivity: "Are you sure to delete this activity? Please accept to continue",
	// Schedule
	TitleConfirmEventCreate: "Created schedule",
	TextConfirmEventCreate: "The schedule was successfully created",
	TitleConfirmEventDelete: "Deleted schedule",
	TextConfirmEventDelete: "The selected schedule was successfully deleted",
	TitleConfirmEventUpdate: "Updated schedule",
	TextConfirmEventUpdate: "The selected schedule was successfully updated",
	DeleteEvent: "Are you sure to delete this schedule? Please accept to continue",
	PopupScheduleTitleCreate: "Create new schedule",
	PopupScheduleTitleUpdate: "Update schedule",
	MODULE_ROLE: {
		Role: "Role",
		Roles: "Roles",
		Description: "Description",
		SelectRole: "Please select a role",
		Created: "Created",
		Action: "Actions",
		RoleList: "Role list",
		TitleCrear: "Create Role",
		TitleUpdate: "update Role",
		ErrorName: "* Please enter the role name",
		ErrorDescription: "* Please enter a description for the role",
		labelName: "Role name",
		ValidName: "The role name field is required",
		labelAlias: "Alias",
		ValidAlias: "The alias field is required",
		labelDescription: "Description",
		ValidDescription: "The description field is required",
		Cancel: "Cancel",
		Ok: "Accept",
		Update: "Update",
		Add: "Add New",
		titleDelete: "Delete role",
		msgDelete: "This could conflict with users who have this role. Do you want to remove this role anyway?",
		Removed: "Removed",
		msgRemoved: "The role was successfully deleted",
		Hecho: "Created",
		msgHecho: "The role was successfully created",
		Change: "Updated",
		msgChange: "The role was successfully updated",
		ErrorMessages: {
			ConsultRoles: "Consulting the roles",
			ConsultPermission: "Consulting permissions",
			ConsultRolePermissions: "Consulting the relationships between roles and their permissions",
			msgChange: "The role has not been updated",
			msgHecho: "The role has not been created",
		},
		UpdateForm: "Form to edit a role",
	},
	MODULE_PERMISSION: {
		Permissions: "Permissions",
		Role: "Permission",
		Description: "Description",
		ListOfPermissions: "List of permissions",
		Created: "Created",
		Action: "Actions",
		TitleCrear: "Create Permission",
		TitleUpdate: "Update Permission",
		ErrorName: "* Please enter the permit name",
		ErrorDescription: "* Please enter a description for permission",
		labelName: "Permission name",
		ValidName: "The name of permission field is required",
		labelDescription: "Description",
		ValidDescription: "The description field is required",
		labelRol: "Select the roles <b>(Optional)</b>",
		Cancel: "Cancel",
		Ok: "Accept",
		Create: "Create",
		Update: "Update",
		Add: "Create New",
		titleDelete: "Delete permission",
		msgDelete:
			"This could conflict with users who have this permission. Do you want to remove this permission anyway?",
		Removed: "Deleted",
		msgRemoved: "The permission was successfully deleted",
		Hecho: "Created",
		msgHecho: "The permission was successfully created",
		Change: "Updated",
		msgChange: "The permission was successfully updated",
	},
	MODULE_SOURCE: {
		Divider1: "Basic information",
		Availability: "Availability",
		Divider2: "Activities",
		Divider3: "Capacities",
		Divider4: "Additional Information",
		Option: "*Optional",
		legend1: "(you can add a maximum of 3 capacities)",

		Resource_type: "Resource type",
		id: "ID",
		names: "Names",
		lastName: "Last Name",
		Select_rol: "Select role",
		Select_status: "Select status",
		User_name: "User name",
		Email: "Email",
		Country: "Country",
		Departament: "Department",
		City: "City",
		address: "Address",
		Completed: "Completed field",
		Obligatory: "*Obligatory field",
		Costs: "Costs",
	},
	DrawingTools: {
		Tools: "Tools",
		Circle: "Circle",
		Polygon: "Polygon",
		Rectangle: "Rectangle",
		RemoveShape: "Remove Shape",
		Selection: "Selection",
		Polyline: "Polyline",
		Help: "Help",
	},
	RouterSelection: {
		RouterSelection: "Router By Selection",
		CheckedAll: "Check All",
		ActivityAssignment: "Activity Assignment",
		TotalVisitPointSelected: "Total puntos de visita seleccionados",
		AssignActivities: "Assign Activities",
		ActivityAssignmentInfo: "It is necessary to assign one activity in order to continue with the process.",
		Activities: "Activities",
		Activity: "Activity",
		Total: "Total",
		TotalVisitPointInside: "found inside of the area",
		TotalVisitPointInsideToContinue: "Please, select one visit points or more to continue.",
		TotalResourceInsideToContinue: "Select one or more resources to continue.",
		VisitPoints: "Visit Points",
		TitleConfirmRecordCreate: "Created Record",
		TextConfirmRecordCreate: "The record was successfully created",
		TitleConfirmRecordDelete: "Deleted Record",
		TextConfirmRecordDelete: "The selected record was successfully deleted",
		TitleConfirmRecordUpdate: "Updated Record",
		TextConfirmRecordUpdate: "The selected record was successfully updated",
		DeleteRecordTextConfirm: "Are you sure to delete this record? Please accept to continue",
		UpdateRecordTextConfirm: "Are you sure to update this record? Please accept to continue",
		UpdateAllRecordTextConfirm:
			"Depending on the total selected, updating all the selected records may take a while. Are you sure to continue?",
		CleanMap: "Clean Map",
		validateStep1Error: "It's necessary to select visit points from the map, in order to next with the process.",
		validateStep2Error: "It's necessary to select resources, in order to next with the process.",
		validateStep3Error:
			"It's necessary to assign an activity to all of the visiting points to continue with the process.",
		Step1Title: "Select Visit Points",
		Step2Title: "Select Resources.",
		Step3Title: "Run Process",
		Hours: "Hours",
		Minutes: "Minutes",
		Seconds: "Seconds",
	},
	LoginModule: {
		CodeErrorGreater: "The code field may not be greater than 6 characters",
		CodeErrorToShort: "The code field must be at least 6 characters",
		CodeErrorRquired: "The code field is required",
		CodeErrorAlphaNum: "The code field may only contain alpha-numeric characters",
	},
	// Company Config Crud Module
	CompanyConfigCrud: "Company Configuration",
	CompanyAddNewField: "Add additional field",
	CompanyConfigCrudFormTitleCreate: "Form to create a company configuration",
	CompanyConfigCrudFormTitleEdit: "Form to edit a company configuration",
	CompanyConfNameAddLabel: "Field Name",
	CompanyConfValueAddLabel: "Value",
	CompanyConfNameAddValidMessage: "Alphabetic characters only, no spaces",
	CompanyConfValueAddValidMessage: "Please enter value here",
	DeleteCompanyConf: "Are you sure to delete this config company?",
	TitleConfirmCompanyConfigDelete: "Deleted configutation company",
	TextConfirmCompanyConfigDelete: "The selected configuration was successfully deleted",
	TitleConfirmCompanyConfigCreate: "Configuration company created",
	TextConfirmCompanyConfigCreate: "The configuration was created successfully",
	TitleConfirmCompanyConfigUpdate: "Updated configutation company",
	TextConfirmCompanyConfigUpdate: "The selected configuration was updated successfully",
	NewCompanyConfig: "New Config Company",
	UpdateCompanyConfig: "Update Config Company",
	ListOfCompaniesConfig: "List of Config Companies",
	TitleWarningExistPropertyCompanyConfig: "It already exists",
	TextWarningExistPropertyCompanyConfig: "The value to enter is already",
	ListCompanyConfig: {
		TypeConfigName: "Name Configuration Type",
	},
	ErrorFields: {
		Title: "Error in fields",
		Text: "Some fields are missing or invalid!",
	},
	RoutingType: {
		Fleetrouting:
			"Optimization tool created by Google, designed to tackle the most difficult problems of vehicle routing, flows, integer and linear programming.",
		RutaOptima:
			"Default Route Optimizer created by Servinformacion, based on OR-Tools, is a suite of open source tools.",
		OpenRoute: "Open source route optimizer.",
		AvailableRoutingTypes: "Available Routing",
		SelectRoutingType: "Select the routing type",
		AskMeAgain: "Ask me again",
		SelectedRouter: "Selected Router",
		RoutingType: "Routing Type",
		MaximizeWindow: "Maximize Window",
		TourPlanning:
			"HERE Tour Planning, provides a Cost- or time-optimized tours for all vehicles in a fleet, incorporating vehicle type and capacity, to maximize utilization. Live traffic-enabled vehicle optimization, using truck attributes where appropriate.",
		SelectMeansTransport: "Select your means of transport",
		SelectMeansTransportText: "What means of transport are you going to use to optimize the routes?",
		Transport: "Means of transport",
	},
	Login: {
		Subtitle: "Welcome, login to use the platform.",
		Email: "Email",
		Password: "Password",
		Remember: "Remember me",
		ForgotPassword: "Forgot Password?",
		Register: "Register",
		Disabled: "The user account has been disabled by an administrator.",
		Login: "Login",
		ConnectingWithDatarutas: "Connecting with Datarutas...",
		YouHaveSuccessfullyLoggedInToDatarutas:
			"You have successfully logged in to Datarutas! Now you can continue with your activities",
		CouldNotConnectToDatarutas:
			"Could not connect to Datarutas. Please check your internet connection and try again. If the problem persists, please contact the platform administrator.",
		ValidMessages: {
			Email: "The Email field is required and should be a valid email",
			Password: "The password is required, minimum 6 characters - maximum 18",
			InvalidPassword: "The password is invalid or the user does not have a password.",
			UserNotFound: "Something went wrong validating the credentials",
			TooManyRequests:
				"Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.",
			CompanyReachedWorkingDate: "The company reached the date of work",
			InvalidCode: "Invalid authentication code",
		},
		LoginWithGoogle: "Login with Google account",
		EnableTwoFactorAuthentication: "Enable two factor authentication",
		TwoFactorAuthentication: "Tow factor authentication",
		TwoFactorAuthenticationText:
			"Enter the 6-digit code that was sent to you by email to continue with the authentication",
		ResendAuthCodeEmail: "If the message with the authentication code hasn't arrived, you can request a resend.",
		ResendCode: "Resend code",
		CodeSent: "Verification code sent",
		CustomTokenMissing: "Authentication token not received. Please log in again.",
		FirebaseAuthError: "Error authenticating with Firebase.",
		Warning: "Warning",
		ServerError: "An error occurred while contacting the server.",
	},
	RecoverPassword: {
		Title: "Recover password",
		Subtitle: "Please enter your email address and we'll send you instructions on how to reset your password.",
		Email: "Email",
		ToLogin: "To Login",
	},
	ResetPassword: {
		TitleReset: "Reset password",
		TitleCreate: "Create password",
		Subtitle: "Please enter your new password.",
		VerificationCode: {
			Title: "Verification code",
			Text1: "A verification code was sent to the email. if the code does not arrive,",
			Text2: "send it again",
		},
		Code: "Code",
		YourPassword: "Your password",
		ConfirmPassword: "Confirm Password",
		ToLogin: "To Login",
		Reset: "Reset",
		ValidPassword1: "The password field must be at least 6 characters",
	},
	Indicators: {
		Indicators: "Indicators",
		IndicatorList: "Indicator List",
		CreateIndicator: "Create Indicator",
		TitleConfirmIndicatorCreate: "Created Indicator",
		TextConfirmIndicatorCreate: "The indicator was successfully created",
		TitleConfirmIndicatorDelete: "Deleted Indicator",
		TextConfirmIndicatorDelete: "The selected indicator was successfully deleted",
		TitleConfirmIndicatorUpdate: "Updated Indicator",
		TextConfirmIndicatorUpdate: "The selected indicator was successfully updated",
		DeleteIndicator: "Are you sure to delete this indicator? Please accept to continue",
		UpdateIndicator: "Update Indicator",
		Visualizer: "Visualizer",
		AlertVisualizar: "Visualize Indicator",
		AlertVisualizarInfo: "To view an indicator, click on an item in the list that you want to view.",
		IndicatorNotFound: "There are not indicators or doesn't exists",
	},
	AssignedTeams: {
		Teams: "Teams",
		TotalTeams: "Teams Total",
		Team: "Team",
		AssignedTeam: "Asign Team",
		AssignTeams: "Asign Teams",
		AssignedTeams: "Assigned Teams",
		AssignedTeamToltip: "Load the list of available teams to continue with the assignment.",
		ShowAssignedTeam: "Show Assigned Teams",
		NoAssignedTeams: "There are no assigned teams",
		ShowAssignedTeamToltip: "Show the list of the assigned teams.",
		AssignedTeamRequired: "La assignation of the team is required",
		ClickOnButton: "Click on button",
		DeleteAllTeams: "Delete all of teams",
		Columns: "Columns",
		ColumnsText: "Select the columns you want to render in the table",
	},
	VisitPoints: {
		CreateVisitPoint: "Create visit point",
		UpdatePointofVisit: "Update point of visit",
		Add: "Add",
		Georeferencer: "Georeferencer",
		AddressCouldBeNotGeoreferenced: "Address could be not georeferenced",
		SitidataGeoreverseToken: "The Sitidata api georeverse token is not enabled for this country",
		SitidataNoEnabled: "SITIDATA API not enabled for this company.",
		YouAreAboutToDeleteTheVisitPoint: "You are about to delete the record with identification",
		Search: "Search",
		AllVisitPoints: "All Visit Points",
		ViewPointOfVisit: "View point of visit",
		ListVisitPoint: "Visit Point List",
		Assig: "Assign",
		AssignVisitPoints: "Assign visit points",
		AssignedVisitPoint: "Assigned visit point",
		AssignedVisitPoints: "Assigned visit points",
		NoAssignedVisitPoints: "There are no assigned visit points",
		AssigneVisitPointText: "Select the viewpoints you want to assign.",
		AssignVisitPointToltip: "Load the list of available visit points to continue.",
		AssignAllVisitPointText: "Assign all platform visit points",
		SelectObjectType: "Select object type",
		ObjectType: "Object type",
		DeleteAllVisitPoints: "Delete all visit points.",
		DeleteAllText: "You are about to delete all",
		SelectedPointsOf: "Selected Points of",
		SelectedPointOf: "Selected Point of",
		ShowOnlySelectedVisitPoints: "Show only selected visit points",
		VisitingPointsSelected: "Visiting points selected",
		SelectedInformation: "Selected information",
		Demands: "Demands",
		Location: "Location",
		MassiveActionsVisitPoints:
			"This option allows you to massively update the values ​​of the demand and type of service fields at the selected visit points",
		MakeMassiveSelectionFromPickupToDelivery: "Massively select the visit points selected in the delivery service",
		MakeMassiveSelectionFromDeliveryToPickup: "Massively select the visit points selected in the pickup service",
		FindAddress: {
			Title: "Direction found",
			Text: "Georeferentiated address successfully.",
		},
		ErrorFindAddress: {
			Title: "Address not found",
			Text: "The georeferencer did not find the address entered",
		},
		MissingAddress: {
			Title: "Address is Required",
			Text: "The address is required by the georreferencer.",
		},
		ErrorFindCountry: {
			Title: "Coverage not found",
			Text: "Check that the chosen country matches the country where you are dragging the marker",
		},
		Success: {
			Title: "Visit point created",
			Text: "Visit point created successfully",
		},
		EditSuccess: {
			Title: "Visit Point Update",
			Text: "The visit point was successfully updated",
		},
		ErrorRegisterValidate: {
			Title: "Missing fields",
			Text: "Missing fields in additional information",
		},
		ValidData: {
			Title: "Validate the data",
			Text: "Missing some important fields",
		},
		CellRenderer: {
			DeleteRecord: "You are about to delete",
			DeleteSuccess: {
				Title: "Visit Point Deleted",
				Text: "The selected visit point was successfully deleted",
			},
		},
		VisitPointNotFound: {
			Title: "Visit Point not found",
			Text1: "Visit point record with id:",
			Text2: "not found.",
		},
	},
	Group: {
		Group: "Group",
		Groups: "Groups",
		AddGroup: "Add group",
		CreateGroup: "Create group",
		OptimizationGroup: "Optimization group",
		OptimizationGroups: "Optimization groups",
		ListOfOptimizationGroups: "List optimization groups",
		UpdateGroup: "Update group",
		TotalOptimizations: "No. Optimizations",
		TotalCreated: "Total Created",
		TotalProcessed: "Total Processed",
		TotalFinalized: "Total Finalized",
		TotalErrors: "Total Errors",
		OptimizationsByGroup: "Optimizations by group",
		Messages: {
			Delete: "Are you sure to remove the capacity? Please accept to continue",
			TitleConfirmDelete: "Eliminated Group",
			TextConfirmDelete: "The selected group has been deleted.",
			TitleConfirmCreate: "Group Created",
			TextConfirmCreate: "The group was successfully created",
			TitleConfirmUpdate: "Updated group",
			TextConfirmUpdate: "The group was successfully updated",
			DeleteAll: "Are you sure to remove all groups from the table?",
		},
		DeleteGroup: {
			Text1: "Are you sure to delete the group",
			Text2: "Please accept to continue.",
		},
		CellRenderer: {
			DeleteRecord: "You are about to delete",
			DeleteSuccess: {
				Title: "Group deleted",
				Text: "The selected group was successfully deleted",
			},
		},
	},
	Optimization: {
		Optimization: "Optimization",
		Optimizations: "Optimizations",
		CreateOptimization: "Create optimization",
		ListOptimizations: "List optimizations",
		ListOfOptimizations: "List of optimizations",
		OptimizationHistory: "Optimization history",
		ConfigurePeriod: "Configure period",
		AcceptsNumbersLettersAndTheDashSign:
			"Please enter a valid format for the name keeping in mind that it only accepts numbers, letters and the dash sign",
		Distance: "Distance",
		Fixed: "Fixed",
		Time: "Time",
		TraveledHour: "Traveled hour",
		VehicleTime: "Vehicle time",
		OptimizationPeriod: "Optimization period",
		TheProfileOfEachSelectedVehicle: "The profile of each selected vehicle",
		OptimizationsFinished: "Optimizations finished",
		OptimizationsCreated: "Optimizations created",
		OptimizationsInProgress: "Optimizations in progress",
		OptimizationsWithErrors: "Optimizations with errors",
		OptimizationsPerRouter: "Optimizations per router",
		OptimizationsCompleted: "Optimizations Completed",
		OptimizationsCompletedByRouter: "Optimizations completed by router",
		OptimizationProfileVehicleText:
			"Review the vehicles selected for optimization and make sure they all have the appropriate profile before proceeding. If any vehicle does not have a profile assigned to it, the standard 'car' profile will automatically be applied.",
		ValidateOptimizationVisitpointText: "To continue it is necessary to have a minimum of two visit points added.",
		ValidateOptimizationResourceText: "To continue, you must add at least one resource.",
		TheUploadedFilesAreTemporaryForOptimization:
			"The uploaded files are temporary for optimization and will be deleted when you switch to the selected data option",
		OnlyMaximizeOrMinimizeTourCountAllowed:
			"Only maximize or minimize tour count should be selected at a time, not both at the same time.",
		DeleteOptimization: {
			Text1: "Are you sure to delete the optimization",
			Text2: "Please accept to continue.",
		},
		CellRenderer: {
			DeleteRecord: "You are about to delete",
			DeleteSuccess: {
				Title: "Optimization deleted",
				Text: "The selected optimization was successfully deleted",
			},
		},
		Messages: {
			"is not valid": "This is not valid data",
			"the longitude coordinate is out of bounds": "The longitude coordinate is out of bounds",
			"the latitude coordinate is out of bounds": "The latitude coordinate is out of bounds",
			"the longitude coordinate is not valid": "The longitude coordinate is not valid",
			"the latitude coordinate is not valid": "The latitude coordinate is not valid",
			"minimum time_service 00:00:00": "Minimum time_service 00:00:00",
			"Init hour window greater than end hour window": "Init hour window greater than end hour window",
			"Init date/hour window outside of global window": "Init date/hour window outside of global window",
			"End date/hour window outside of global window": "End date/hour window outside of global window",
			"Init hour window outside of global window": "Init hour window outside of global window",
			"End hour window outside of global window": "End hour window outside of global window",
			"Init date/hour break outside of vehicle time window":
				"Init date/hour break outside of vehicle time window",
			"End date/hour break outside of vehicle time window": "End date/hour break outside of vehicle time window",
			enum: "The value does not match any of the allowed values in the list",
			type: "The type of the value does not match the type specified in the data schema",
			required: "A specific property is required in the data, but it is absent",
			pattern: "The value does not meet the required pattern in the data schema",
			format: "The value does not comply with the specified format, such as an email address, a URL, a date, etc.",
			minimum: "The value is less than the minimum value allowed",
			maximum: "The value is greater than the maximum value allowed",
			minLength: "The length of the value is less than the minimum allowed length",
			maxLength: "The length of the value is greater than the maximum length allowed",
			minItems: "The number of items in an array is less than the minimum number allowed",
			maxItems: "The number of elements in an array is greater than the maximum number allowed",
			Unknown: "An unknown error occurred during optimization, inspect error.serverResponse",
		},
	},
	RoutingTypeSearch: "Routing Type",
	VValidateMessage: {
		"The name field is required": "The name field is required",
		"Please enter your Skill name here": "The field is required",
		"Please enter your break name here": "The field is required",
		"Please enter your company name here": "The field is required",
		"The name field may not be greater than 50 characters": "The name field may not be greater than 50 characters.",
		"The name field may not be greater than 125 characters":
			"The name field may not be greater than 125 characters.",
		"The name field may not be greater than 128 characters":
			"The name field may not be greater than 128 characters.",
		"The name field may not be greater than 150 characters":
			"The name field may not be greater than 150 characters.",
		"The description field may not be greater than 150 characters":
			"The description field may not be greater than 150 characters.",
		"The description field may not be greater than 250 characters":
			"The description field may not be greater than 250 characters.",
		"Please enter name here": "Please enter name here",
	},
	TimeWindow: {
		TimeWindows: "Time windows",
		TimeWindow: "Time window",
		ListOfTimeWindows: "List of time windows",
		CreateTimeWindows: "Create time windows",
		AddTimeWindows: "Add time windows",
		Duration: "Duration",
		Daily: "Daily",
		Weekly: "Weekly",
		Monthly: "Monthly",
		Day: "Day",
		Month: "Month",
		Week: "Week",
		Hours: "Hours",
		Minutes: "Minutes",
		Minute: "Minute",
		EveryDay: "Every day",
		Every: "Every",
		FromThe: "From the",
		StartingAtMinute: "Starting at minute",
		BetweenMinute: "Between minute",
		OfTheMonth: "Of the month",
		SpecificDayOfTheWeek: "Specific day of the week (choose one or more)",
		Programming: "Programming",
		SpecificDayOfTheMonth: "Specific day of the month (choose one or more)",
		EveryMonth: "Every month",
		MonthsStartingAtMonth: "Months starting at month",
		SpecificMonth: "Specific month (choose one or many)",
		EveryMonthBetween: "Every month between",
		And: "And",
		EveryHour: "Every hour",
		HourStartingAtHour: "Hour starting at hour",
		SpecificHour: "Specific hour (choose one or many)",
		EveryHourBetweenHour: "Every hour between hour",
		EveryMinute: "Every minute",
		MinuteStartingAtMinute: "Minute starting at minute",
		SpecificMinute: "Specific minute (choose one or many)",
		EveryMinuteBetweenMinute: "Every minute between minute",
		DayOfMonth: "Day of month",
		DayOfWeek: "Day of week",
		EveryDayBetween: "Every day between",
		TheChosenTimeIsNotValid: "The chosen time is not valid",
		Schedule: "Schedule",
		UpdateTimeWindow: "Update time window",
		ViewTimeWindow: "View time window",
		AssignedTimeWindows: "Assigned time windows",
		AssignTimeWindows: "Assign time windows",
		AssignTimeWindowTooltip: "Load the list of available time windows to continue",
		DeleteAllTimeWindows: "Delete all time windows.",
		NoAssignedTimeWindows: "No time windows assigned",
		DeleteAllText: "You are about to delete all",
		SoftTimeWindow: "Soft time windows",
		PenaltyForAnticipation: "Penalty for anticipation",
		PenaltyForLateness: "Penalty for lateness",
		SelectTimeWindows: "Select time windows...",
		TheSumOfTheInitialDurationAndTheFinalDuration:
			"The sum of the initial duration and the final duration must be less than or equal to the total duration of the time window",
		PleaseCompleteThegeneralTimeWindow: "Please complete the general time window data first before proceeding.",
		ThisWillBeEliminatedSecondTimeWindow: "This will be eliminated if you add a second time window",
		DateAndTimeMustBeWithinTheGeneral: "Date and time must be within the general time window range",
		RemoveAllOtherTimeWindowsToEnable:
			"Remove all other time windows to enable the configuration of a soft time window.",
		ItIsNotPossibleToAddAnotherTimeWindow:
			"It is not possible to add another time window while there is an active soft time window. Please delete or edit it before proceeding.",
		ThereAreCurrentlyNoTimeWindowsAvailable:
			"There are currently no time windows available on the platform. Add a new one using the option",
		AllDataRequestedAddedTimewindowAreRequired:
			"All data requested in the added time window are required to continue",
		NameMonth: {
			January: "January",
			February: "February",
			March: "March",
			April: "April",
			May: "May",
			June: "June",
			July: "July",
			August: "August",
			September: "September",
			October: "October",
			November: "November",
			December: "December",
		},
		NameWeek: {
			Monday: "Monday",
			Tuesday: "Tuesday",
			Wednesday: "Wednesday",
			Thursday: "Thursday",
			Friday: "Friday",
			Saturday: "Saturday",
			Sunday: "Sunday",
		},
		DeleteTimeWindow: {
			Text1: "¿Are you sure to remove the time window",
			Text2: "Please accept to continue.",
		},
		CellRenderer: {
			DeleteRecord: "You are about to delete",
			DeleteSuccess: {
				Title: "Removed time window",
				Text: "The selected time window was successfully deleted",
			},
		},
		Messages: {
			TitleConfirmCreate: "Time Window Created",
			TextConfirmCreate: "The time window was created successfully",
			TitleConfirmUpdate: "Updated time window",
			TextConfirmUpdate: "The time window was successfully updated",
		},
		TimeWindowNotFound: {
			Title: "Time window not found",
			Text1: "Time window record with id:",
			Text2: "not found.",
		},
	},
	DesignConfig: {
		TypeField: "Type Field",
		MinimumCharacterLength: "Minimum character length",
		MaximumCharacterLength: "Maximum character length",
		MinimumVal: "Minimum value",
		MaximumVal: "Maximum value",
		Option: "Option",
		SwitchText: "Switch active / inactive",
		SelectMinimumOneOption: "Select Minimum One Option",
		LoadOptions: "Load options list",
		CalendarStatus: "Calendar status",
		AllowValues: "This property can receive one of the following values",
		Date: "Date",
		DateTime: "Hour",
		Text: "Text",
		Number: "Number",
		Email: "Email",
		Url: "Url",
		Select: "Selection",
		File: "File",
		Image: "Image",
		Coordinates: "Coordinates",
		DefaultLocation: "Default Location",
		Radio: "Several options",
		Checkbox: "Checkbox",
		Dropdown: "Dropdown",
		Switch: "Boolean",
		Composed: "Composed",
		MultipleChoice: "Multiple choice",
		TypeConfig: "Configuration Type",
		NewTypeConfig: "New Type of Configuration",
		NewTypeConfigRequired: "Type of Configuration required",
		UpdateTypeConfig: "Update Type of Configuration",
		ListOfTypeConfig: "List of Configuration Types",
		InputNameTypeConfig: "Type name",
		ButtonAddTypeConfig: "Add",
		TitleConfirmTypeConfigUpdate: "Type Configuration modified",
		TextConfirmTypeConfigUpdate: "The selected configuration type was successfully modified",
		TypeConfigCrudFormTitleCreate: "Form to create a configuration type",
		TypeConfigCrudFormTitleEdit: "Form to edit a configuration type",
		TitleSuccessTypeConfigCreated: "Type Configuration created",
		TextSuccessTypeConfigCreated: "The configuration type was created successfully",
		TitleSuccessTypeConfigCreatedError: "Error creating configuration type",
		TextSuccessTypeConfigCreatedError: "The configuration type has not been created",
		DeleteTypeConf: "Are you sure to delete this configuration type?",
		TypeConfigConfigName: "Type Config Name",
		TypeConfigStatus: "Status",
		TypeConfigAddDateOn: "Added on",
		Property: "Property",
		ChangeName: "Change name",
		DeleteField: {
			Text1: "Are you sure to eliminate the field",
			Text2: "Please accept to continue.",
		},
		UserDeleted: {
			Title: "User Deleted",
			Text: "The selected user was successfully deleted.",
		},
	},
	Setting: {
		Setting: "Setting",
		NewConfiguration: "New Configuration",
		VisualSetting: "Visual Setting",
		ThemeColor: "Theme Color",
		NavbarColor: "Navbar Color",
		ConfirmSave: "Do you want to save the applied changes?",
		Saved: "Changes saved successfully",
		SelectCompany: "Select the company to configure",
		AllowedLogo: "Allowed image files JPG or PNG. Max size of 900kB",
		ImageNotAllowed: "Image not allowed",
		ChooseImage: "Choose Image",
		UploadImage: "Upload Image",
		DeleteImage: "Are you sure to delete the image?",
		ImagenUploaded: "Image has been uploaded successfully",
		TooShortProperties: "Property value is empty or content is too short",
		ValidatorRequiredProperty: "is a required property",
		IsNotStringValid: "Is not a valid string",
		IsGreaterThanMaximum: "Is greater than the maximum value allowed",
		IsLessThanMinimum: "Is less than the minimum value allowed",
		ReviewValues: "Review the values allowed in the configuration types module",
		IsTooLong: "The text string is too long",
		UnexpectedError: "An unexpected error occurred",
	},
	SessionApi: {
		SessionApi: "Session API",
		AccessToken: "Access token",
		ExpireDate: "Expire date",
		ExpireDateError: "La fecha de expiración del token no puede ser mayor a la fecha de operación de la empresa",
		GenerateAccessToken: "Crear nuevo token de acceso por API",
		NotFoundAccessToken: "La empresa no tiene token de accesos por API",
		Copy: "Copy",
		Copied: "Copied",
		CopiedText: "Token copied to clipboard successfully",
		Messages: {
			TitleConfirmCreate: "Token created",
			TextConfirmCreate: "The Token was created successfully",
			TitleConfirmDelete: "Removed Token",
			TextConfirmDelete: "The selected Token was successfully removed",
			TitleConfirmUpdate: "Token Updated",
			TextConfirmUpdate: "The selected Token was successfully updated",
			DepositNotFound: "Token not found",
		},
	},
	ErrorVariable: {
		Textvariable1: "The field is missing or incorrect!",
	},
	Preferences: {
		Preferences: "Preferences",
		ListOfPreferences: "List of preferences",
		FilterSearchTitle: "Type of searches",
		FilterSearchNote: "Only works when searching through additional fields",
		FilterSearchText:
			"Allows you to establish whether the search for visit points or resources is strictly equal to the specified criteria or if the search takes coincidences into account",
		FindExactly: "Search by exact criteria",
		FindCoincidence: "Find by match",
		NumberDays: "Number of days",
		NotificationNumberDays:
			"Configure the number of previous days from which the platform will load and display notifications",
		NotificationNumber:
			"Set the maximum number of notifications that can be displayed since the last notification received",
		DeleteOldNotification:
			"When launching the platform, automatically delete notifications older than the previous days established previously",
		FilterSearchExactText:
			"Enabling search by exact criteria sets the search in the list to be strictly equal to the specified criteria",
		AllowsFindExactly:
			"Allows you to set whether the search of the selected modules is strictly equal to the specified criteria",
	},
	ManualData: {
		Required: "Required",
		InformationFound: "Information found",
		ErrorsFound: "Errors found during the upload information process",
		ErrorsNotFound: "No errors found during the information upload process",
		ValidatorRequiredProperty: "is a required property, please remove it",
		AlreadyRegistered: "Already registered",
		DateLessThanCurrentDate: "Date less than current date",
		NotRegistered: "Not registered",
		ValidatorAdditionalProperties: "Additional properties are not allowed, delete its",
		TooShortProperties: "Property value is empty or content is too short",
		country: "Country",
		city: "City",
		address: "Address",
		identification: "Identification",
		phone: "Phone",
		name: "Name",
		cx: "CX",
		cy: "CY",
		date: "Date",
		ManageError: "Manage Errors",
		ProcessAgain: "Process Again",
		ProcessAgainText:
			"Reprocess the file; this will try to create new records on the system, so note that the records must not exist.",
		ProcessAgainTextSuccess:
			"Reprocess the file is working in the background, please check or wait for the system notifications to know the status process.",
		DownloadFile: "Download File",
		Download: "Download",
		AddedOn: "Added",
		PropertyError: "Error on the property",
		ShowErrors: "Show Errors",
		FixErrorsHere: "Fix errors here",
		FixErrorsModule: "Fix errors on module",
		SaveChanges: "Save changes",
		ActivityNotRegistered: "Activity is not registered",
		EditAlertText: "Edit the selected property, respect its format and note that some values must exist.",
		Property: "Property",
		ResourceHasNoActivities: "Resource do not have any activities",
		SaveRecordError: "Save record error",
		DaneCodeNotFound: "Dane code not found",
		DuplicateRecordInExcel: "Duplicate record in excel",
		InitHourLessThanCurrentTime: "Init hour less than current time",
		ErrorEndHour: "Error on end hour",
		ErrorInitHour: "Error on init hour",
		ErrorDate: "Error on date",
		CoordinatesCouldBeNotFound: "Coordinates could be not found",
		AddressCouldBeNotGeoreferenced: "Address could be not georeferenced",
		TimeDataFormat:
			"The format is not valid, the correct format should be similar for date YYYY-mm-dd  or time HH:mm:ss",
		SitidataGeoreverseToken: "The Sitidata api georeverse token is not enabled for this country",
		InvalidValue: "has an invalid value, only character strings are allowed",
	},
	OptimizerManager: {
		ManageOptimizers: "Manage optimizers",
		CreateConfiguration: "Create configuration",
		UpdateConfiguration: "Update configuration",
		PointsPerDay: "Points per day",
		PointsPerMonth: "Points per month",
		PointsPerWeek: "Points per week",
		PointsTotal: "Total points",
		PointsSubscriptionMonthly: "Monthly subscription points",
		EnableOptimizationByTheWebPlatform: "Enable optimization by the web platform",
		EnableOptimizationByAPIConsumption: "Enable optimization by API consumption",
		CreateOptimizerConfiguration: "Create optimizer configuration",
		Optimizers: "Optimizers",
		OptimizerConfigurationList: "Optimizer Configuration List",
		optimizerCompanyRequiredText:
			"The company requires the configuration of a specific route optimizer, please contact the platform administrator to configure it",
		DeleteOptimizerManager: {
			Text1: "¿You are sure to delete the configuration with Id",
			Text2: "Please accept to continue.",
		},
		CellRenderer: {
			DeleteRecord: "You are about to eliminate",
			DeleteSuccess: {
				Title: "Configuration deleted",
				Text: "The selected configuration has been successfully deleted",
			},
		},
		Success: {
			Title: "Optimizer configuration created",
			Text: "Optimizer configuration successfully created",
		},
		EditSuccess: {
			Title: "Optimizer configuration updated",
			Text: "Optimizer configuration was successfully updated",
		},
		ErrorMessage: {
			TheOptimizationApiAlreadyExistsForTheEnterprise: "The optimization api already exists for the enterprise",
			ApiKeyIsNotRequiredForThisOptimizationApi: "The api key is not needed for this optimization api",
			NotAValidDate: "Not a valid date",
			DateLessThanCurrentDate: "Date less than the current date",
			ThePointsperdayFieldMustBe2147483647OrLess: "The pointsperday field must be 2147483647 or less",
			ThePointsPerWeekFieldShouldBe2147483647OrLower: "The points per week field should be 2147483647 or lower",
			ThePointsPerMonthFieldMustBe2147483647OrLower: "The points per month field must be 2147483647 or lower",
			TheTotalPointsFieldMustBe2147483647OrLower: "The total points field must be 2147483647 or lower",
			ThePointsSubscriptionMonthlyFieldMustBe2147483647OrLess:
				"The points subscription monthly field must be 2147483647 or less",
			TheTotalPointsFieldMustBe4294967295OrLower: "The value entered must be 4294967295 or lower",
		},
	},
	Vehicles: {
		Vehicle: "Vehicle",
		Vehicles: "Vehicles",
		CreateVehicle: "Create vehicle",
		UpdateVehicle: "Update vehicle",
		YouAreAboutToDeleteTheVehicle: "You are about to delete the record with ID",
		AllVehicles: "All vehicles",
		ViewVehicles: "View vehicle",
		ListOfVehicles: "List Of Vehicles",
		AssignVehicles: "Assign vehicles",
		AssignedVehicle: "Assigned Vehicle",
		AssignedVehicles: "Assigned Vehicles",
		NoAssignedVehicles: "No vehicles assigned",
		AssigneVehicleText: "Select the vehicles you want to assign.",
		AssignVehicleToltip: "Load the list of available vehicles to continue",
		AssignAllVehicleText: "Assign all vehicles on the platform",
		DeleteAllVehicles: "Delete all vehicles",
		DeleteAllText: "You are about to delete all",
		SelectedPointsOf: "Selected vehicles from",
		SelectedPointOf: "Selected Vehicles from",
		ShowOnlySelectedVehicles: "Show only selected vehicles",
		VehiclesPointsSelected: "Selected vehicles",
		Service: "Service",
		ImportResourcesToVehicles: "Import resources to vehicles",
		ImportResources: "Import resources",
		ExportResourcesToVehicles: "Export resources to vehicles",
		PermittedVehicles: "Permitted vehicles",
		CostPerVehicle: "Cost per vehicle",
		CurrentlyThereAreNoVehiclesInTheSystem:
			"There are currently no vehicles created. Add a new one using the available option",
		ThisListOnlyShowsSupervisoryAndExecutive: "Supervisory and executive role resources not in the vehicle module",
		Success: {
			Title: "Vehicle created.",
			Text: "Vehicle created successfully",
		},
		EditSuccess: {
			Title: "Vehicle updated",
			Text: "Vehicle updated successfully",
		},
		CellRenderer: {
			DeleteRecord: "You are about to delete",
			DeleteSuccess: {
				Title: "Vehicle deleted",
				Text: "The selected vehicle was successfully deleted",
			},
		},
		VehicletNotFound: {
			Title: "Vehicle not found",
			Text1: "Vehicle registration with id:",
			Text2: "not found.",
		},
		Record: {
			ListRecord: "Record List",
			RecordNumber: "Record Number",
			UpdateRecord: "Update Record",
			CreateRecord: "Create Record",
			DeleteRecord: "Delete Record",
			DeleteRecordConfirmText: "Are you sure to delete this record from system? Please accept to continue.",
			TitleConfirmRecordCreate: "Created Record",
			TextConfirmRecordCreate: "The Record was successfully created",
			TitleConfirmRecordDelete: "Deleted Record",
			TextConfirmRecordDelete: "The selected record was successfully deleted",
			TitleConfirmRecordUpdate: "Updated Record",
			TextConfirmRecordUpdate: "The selected record was successfully updated",
		},
	},
	Frequency: {
		Frequency: "Frequency",
		Frequencies: "Frequencies",
		ListOfFrequencies: "List of frequencies",
		CreateFrequencies: "Create frequencies",
		AddFrequencies: "Add frequencies",
		UpdateFrequency: "Update frequency",
		ViewFrequency: "View frequency",
		AssignedFrequencies: "Assigned Frequencies",
		AssignFrequencies: "Assign frequencies",
		AssignFrequencyTooltip: "Load the list of available frequencies to continue",
		DeleteAllFrequencies: "Delete all frequencies.",
		NoAssignedFrequencies: "There are no assigned frequencies",
		ThereAreCurrentlyNoFrequenciesAvailable:
			"There are currently no frequencies available on the platform. Add a new one using the",
		DiscardedItems: {
			Title: "Items Discarded Due to Frequencies",
			Message: "The following items have been discarded due to frequency conflicts:",
			Close: "Close",
			Pickup: "Pickup",
			Delivery: "Delivery",
			Vehicle: "Vehicle",
			DiscardedDueToFrequencies: "discarded due to frequencies.",
			Showing: "Showing",
			of: "of",
			items: "items",
		},
		Messages: {
			TitleConfirmCreate: "Frequency Created",
			TextConfirmCreate: "Frequency was successfully created",
			TitleConfirmUpdate: "Frequency updated",
			TextConfirmUpdate: "Frequency was successfully updated",
		},
		DeleteFrequency: {
			Text1: "¿Are you sure you want to delete the frequency",
			Text2: "Please accept to continue.",
		},
		CellRenderer: {
			DeleteRecord: "You are about to delete",
			DeleteSuccess: {
				Title: "Frequency deleted",
				Text: "The selected frequency was successfully deleted",
			},
		},
		FrequencyNotFound: {
			Title: "Frequency not found",
			Text1: "Frequency record with id:",
			Text2: "not found.",
		},
	},
	Jobs: {
		CreateJobPlanning: "Create job planning",
		SelectedJobs: "Selected jobs",
		JobPlanning: "Job Planning",
		MaximumPickupDeliveryTime: "Maximum Pickup-Delivery Time",
		MaximumTimeOfAbsoluteDeviation: "Maximum Time of Absolute Deviation",
		RelativeDeviationLimit: "Relative Deviation Limit",
		PenaltyCost: "Penalty cost",
		ThisJobCannotBeAdded: "This job cannot be added, because one with the same name already exists",
		SpecifiesTheMaximumDuration:
			"Specifies the maximum duration from start of pickup to start of delivery of a job.",
		SpecifiesTheMaximumAbsolute:
			"Specifies the maximum absolute detour time compared to the shortest path from pickup to delivery.",
		ToProceedYouMustAddAtLeast:
			"To proceed, you must add at least one visit point in both the pickup and delivery services",
		JobsAreUsedToAssociateADeliveryWithAPickup:
			"Jobs are used to associate a delivery with a pickup. This allows the same vehicle to handle both tasks, optimizing routes and resources. Although it is possible to assign more than one delivery or pickup to a single job, this flexibility enables the optimizer to choose the best option for performing the pickup and/or delivery. However, in the final result, each job will be configured to handle only one pickup and one delivery.",
		AddJobsByFileUpload: "Add jobs",
		JobsWereSuccessfullyAdded: "Jobs were successfully added",
		AllowedJobFiles: "Allowed job files",
		UploadedJobFile: "Uploaded file",
		MaximumFileSelectionForJobs: "Maximum file selection for jobs has been reached",
		CostPerVehicle: "Cost per vehicle",
		CostPerVehicleColumnsRequired: "You must select the vehicle identification and cost columns",
		DownloadTemplate: "Download XLSX template",
		TemplateFileName: "jobs_template.xlsx",
		TemplateDownloadSuccess: "The jobs template was downloaded successfully",
	},
	Territories: {
		Territories: "Territories",
		Territory: "Territory",
		TerritoryID: "Territory ID",
		TerritorySubtitle:
			"Visualize on the map the territories assigned to your routes. Each territory is represented by a colored polygon that defines its coverage area and groups the associated visit points. This functionality allows you to easily identify the distribution of your points in the field.",
		VisualizeTerritoriesOnTheMap: "Visualize territories on the map",
		ViewTerritories: "View Territories",
		AllowOperationsOutsideTheAssignedArea: "Allow operations outside the assigned area",
		TerritoryDoesNotHaveEnough:
			"The territory {n} needs three or more visit points in order to form a polygon on the map.",
	},
	AdvancedObjectives: {
		Objectives: "Objectives",
		AdvancedObjectives: "Advanced objectives",
		AdvancedObjectivesDescription:
			"Advanced objectives provide sophisticated optimization strategies beyond basic objectives. These objectives can be combined to create complex optimization scenarios tailored to the specific needs of each business.",
		AdvancedObjectivesSaved: "Advanced objectives have been saved successfully",
		ConfigureAdvancedObjectives: "Configure advanced objectives",
		AddObjective: "Add objective",
		Objective: "Objective",
		ObjectiveType: "Objective type",
		Configuration: "Configuration",
		SelectObjectiveType: "Select objective type",
		SelectObjective: "Select objective",
		NoAdvancedObjectives: "No advanced objectives",
		AddAdvancedObjectivesDescription: "Add advanced objectives to customize the optimization of your routes.",
		MinimizeUnassigned: "Minimize unassigned assignments",
		MinimizeUnassignedDescription: "Minimize the number of unassigned visit points.",
		EagerDelivery: "Eager delivery",
		EagerDeliveryDescription:
			"Used with the objective to minimize costs to configure the behavior of eager delivery",
		EnableEagerDelivery: "Enable eager delivery",
		TieThreshold: "Tie threshold",
		ImprovementThreshold: "Improvement threshold",
		MinimizeTours: "Minimize tours",
		MaximizeTours: "Maximize tours",
		MinimizeToursDescription: "Minimize the number of tours/routes",
		MaximizeToursDescription: "Maximize the number of tours/routes",
		MinimizeCostDescription: "Minimize the total cost of the solution",
		OptimizeTaskOrder: "Optimize task order",
		OptimizeTaskOrderDescription: "Optimize the order of tasks within the tours",
		MinimizeDistance: "Minimize distance",
		MinimizeDistanceDescription: "Minimize the total distance traveled",
		MinimizeDuration: "Minimize duration",
		MinimizeDurationDescription: "Minimize the total duration of all tours",
		BalanceMaxLoad: "Balance max load",
		BalanceMaxLoadDescription: "Distribute the maximum load evenly among all vehicles",
		BalanceActivities: "Balance activities",
		BalanceActivitiesDescription: "Balance the number of activities between vehicles",
		BalanceDistance: "Balance distance",
		BalanceDistanceDescription: "Balance the distance traveled between vehicles",
		BalanceDuration: "Balance duration",
		BalanceDurationDescription: "Balance the duration of the tours between vehicles",
		MaximizePriorityJobs: "Maximize priority jobs",
		MaximizePriorityJobsDescription: "Maximize the number of priority jobs served",
		MaximizeTerritoryJobs: "Maximize territory jobs",
		MaximizeTerritoryJobsDescription: "Maximize the number of territory jobs served",
		TourOrder: "Tour order",
		TourOrderDescription: "Optimize the order of visits",
		OptimizeTaskPosition: "Optimize task position",
		OptimizeTaskPositionDescription: "Optimize the position of tasks within the tours",
		VisuallyAppealingTours: "Visually appealing tours",
		VisuallyAppealingToursDescription: "Create visually appealing tour forms",
		MinimizeTourOverlap: "Minimize tour overlap",
		MinimizeTourOverlapDescription: "Minimize the overlap between different tours",
		ServeInClusters: "Serve in clusters",
		ServeInClustersDescription: "Serve visit points in geographic clusters.",
		TieBreak: "Tie break",
		TieBreakDescription: "Resolve ties between multiple objectives",
		Threshold: "Threshold",
		BalanceThresholdDescription: "Threshold for the optimization of balance",
		Weight: "Weight",
		WeightDescription: "Weight for the optimization of balance",
		IsConstrained: "Constrain",
		IsConstrainedDescription: "Constrain the objective to be solved by a single objective",
		Tolerance: "Tolerance",
		ToleranceDescription: "Tolerance for the optimization of the objective",
		MaxClusterRadius: "Max cluster radius",
		MaxClusterRadiusDescription: "Max cluster radius for the optimization of the objective",
		TieBreakRules: "Tie break rules",
		TieBreakRulesDescription: "Tie break rules for the optimization of the objective",
		ValidationError: "Validation error",
		AtLeastOneAdvancedObjectiveRequired: "At least one advanced objective is required",
		AllObjectivesMustHaveType: "All objectives must have a selected type",
		TieBreakMustHaveRules: "The tie break objective must have at least one rule",
		TieBreakRulesMustHaveObjective: "The tie break rules must have a selected objective",
		Clear: "Clear",
	},
	FieldDescriptions: {
		identification: "Unique identifier for each record",
		longitude: "Longitude coordinate (decimal format)",
		latitude: "Latitude coordinate (decimal format)",
		priority: "Priority level (number)",
		time_service: "Service time in minutes",
		skills: "Required skills (separated by commas)",
		demand: "Required demand or capacity",
		allowed_vehicles: "Allowed vehicles",
		time_window: "Available time windows",
		additional_info: "Additional information",
		territory_id: "Territory ID",
		profile: "Vehicle profile",
		max_travel_distance: "Maximum travel distance",
		max_travel_duration: "Maximum travel duration",
		init_depot: "Initial depot",
		end_depot: "Final depot",
		capacity: "Vehicle capacity",
		breaks: "Scheduled breaks",
		time_cost: "Time cost",
		traveled_hour_cost: "Traveled hour cost",
		distance_cost: "Distance cost",
		fixed_cost: "Fixed cost",
		strict_territories: "Strict territories",
		territories: "Assigned territories",
		original_identification: "Identifier to group records",
		init_depot_id: "Initial depot coordinates",
		end_depot_id: "Final depot coordinates",
		address: "Address",
		country: "Country",
		status: "Status",
		department: "Department",
		city: "City",
	},
	FieldHints: {
		identification: "Example: ID_001, VEH_001",
		longitude: "Example: -74.0059",
		latitude: "Example: 4.7110",
		priority: "Priority values: 1 (high) to 5 (low)",
		time_service: "In minutes, example: 30",
		skills: "Example: refrigerated, heavy",
		demand: "Example: 100, 2.5",
		time_window: "Attention hours",
		select_multiple: "Select columns for {key}...",
		select_single: "Select column for {key}...",
	},
	FiltersAdvanced: {
		Title: "Filter Panel",
		BasicMode: "Basic",
		AdvancedMode: "Advanced",
		BasicModeTitle: "Basic Filters",
		BasicModeDescription: "Simple search by field and value",
		AdvancedModeTitle: "Advanced Filters",
		AdvancedModeDescription: "Multiple filters with logical operators and sorting",
		SearchBy: "Search by:",
		SelectField: "Select field...",
		EnterValue: "Enter a value...",
		Search: "Search",
		ClearFilters: "Clear Filters",
		FieldSelection: "Field Selection",
		SelectFilterToAdd: "Select filter...",
		Add: "Add",
		Clear: "Clear",
		ActiveFilters: "Active Filters",
		AddValue: "Add value...",
		NoFiltersAdded: "No filters added",
		SelectFieldAbove: "Select a field above to start",
		FilterConfiguration: "Filter Configuration",
		LogicalOperator: "Logical Operator",
		AND: "AND",
		OR: "OR",
		MatchType: "Match Type",
		PartialMatch: "Partial Match",
		ExactMatch: "Exact Match",
		Sorting: "Sorting",
		ApplyFilters: "Apply Filters",
		Searching: "Searching",
		SearchSuccess: "Search completed successfully",
		SearchError: "Error performing search",
		InvalidFilters: "Please complete all filter fields",
		GroupPlaceholder: "Group (optional)",
		NoGroup: "No group",
		AndGroup: "AND Group",
		OrGroup: "OR Group",
	},

	Wizard: {
		Previous: "Previous",
		Next: "Next",
		Generate: "Generate Clustering",
		Close: "Close",
		StepIndicator: "Step {current} of {total}",
		ValidationError: "Please complete all required fields",
		Generating: "Generating Clustering...",
		GeneratingMessage: "Please wait while we process your clustering. This may take a few moments.",
		ConfirmCancel: "Are you sure you want to cancel? All progress will be lost.",
		Minimize: "Minimize",
		Minimized: "Wizard minimized. You can continue interacting with the map.",
		RestoreWizard: "Restore Wizard",
		ContinueCreating: "Continue creating",
		Recommended: "Recommended",
		Easy: "Easy",
		Available: "Available",
		Selected: "Selected",
		LoadAndContinue: "Load and Continue",
		ShowPreview: "Show Preview",
		HidePreview: "Hide Preview",
		PolygonDrawingFinished: "{count} points selected with polygons",
		SelectionComponentNotFound:
			"No se pudo acceder al componente de selección. Intenta cerrar y abrir el wizard nuevamente.",
		Steps: {
			Origin: {
				Title: "Data Origin",
				Subtitle: "Load visit points",
				MainTitle: "Where do your visit points come from?",
				Description: "Choose how you want to load the points you'll use for clustering",
				LoadAll: "Load All Points",
				SkipLoad: "Select Points",
				SkipLoadDesc: "Access the table of available points directly and select the ones you need",
				SelectFromTable: "Select from table",
				OrCreateManually: "Or create manually",
				ContinueToSelection: "Continue to Selection",
				SkipMessage: "You can select points from the table or create them manually",
				LoadSuccess: "{count} points loaded successfully!",
			},
			Selection: {
				Title: "Selection",
				Subtitle: "Choose points for clustering",
				MainTitle: "Select the points you want to group",
				MinimumRequired: "Minimum {min} points required",
				MinimumRequiredPoint: "Minimum 1 point required",
				FromTable: "From Table",
				CreatePoint: "Create Point",
				FromMap: "From Map",
				Quick: "Quick",
				CreateNewPoint: "Create New Point",
				CreateHelp:
					"Manually enter data to create a new visit point. The point will be automatically added to the map and your selection.",
				AddAndSelect: "Add and Select",
				ClearForm: "Clear Form",
				PointsCreated: "Points Created",
				PointCreated: "Point created and added successfully",
				PointRemoved: "Point removed",
				NoID: "No ID",
				DrawPolygons: "Draw Polygons",
				FinishDrawing: "Finish Drawing",
				UndoLast: "Undo Last",
				ClearAll: "Clear All",
				PolygonsDrawn: "polygons drawn",
				PolygonRemoved: "Polygon Removed",
				LastPolygonRemoved: "Last polygon was removed",
				ConfirmClearAllPolygons: "Delete all polygons? Points will be deselected.",
				AllPolygonsCleared: "Polygons Cleared",
				PointsDeselected: "All points were deselected",
				ConfirmCreateAnother: "Do you want to create a new clustering? Current wizard data will be lost.",
				CreatingNew: "Starting new clustering wizard",
				CreateByClick: "Create Point by Click",
				CreateByClickHelp: "Click anywhere on the map to create a new point with those coordinates",
				StartClickCreate: "Activate Click Creation",
				StopClickCreate: "Stop Creation",
				ClickCreateModeActive: "Creation mode active. Click on the map to create a new point",
				EnterIdentification: "Point Identification",
				EnterIdentificationHelp: "Enter the identification for the new point",
				AddressFound: "Address found",
				CoordinatesOnly: "Could not get address. Coordinates",
				CreateCancelled: "Point creation cancelled",
				PointCreatedFromMap: "Point '{identification}' created from map",
				PointsCreatedByClick: "points created",
			},
			Demand: {
				Title: "Demand",
				Subtitle: "Configure capacities",
				MainTitle: "Configure demand for your points",
				Description:
					"Assign demand values (required capacity) to selected points. This step is optional but recommended for more accurate clustering.",
				Optional: "(Optional but recommended)",
				QuickSetup: "Quick Setup",
				QuickHelp: "Apply the same demand value to all selected points",
				IndividualEdit: "Individual Demand Editing",
			},
			Config: {
				Title: "Configuration",
				Subtitle: "Clustering parameters",
				MainTitle: "Configure your clustering",
			},
			Result: {
				Title: "Result",
				Subtitle: "Clustering generated",
				Success: "Clustering Successfully Generated!",
			},
		},
	},

	Clustering: {
		Title: "Clustering",
		ControlPanel: "Control Panel",
		ClusterList: "Cluster List",
		ClustersList: "Clusters List",
		ClusterInfo: "Cluster Information",
		MicroClusterInfo: "Micro Cluster Information",
		ClusterSummary: "Cluster Summary",
		TotalDemand: "Total Demand",
		AvgDemand: "Average Demand",
		MicroClusterId: "Micro Cluster ID",
		PointDetails: "Point Details",
		QuickActions: "Quick Actions",

		// Statistics
		Statistics: "Statistics",
		TotalPoints: "Total Points",
		BalanceMetrics: "Balance Metrics",
		BalanceAnalysis: "Balance Analysis",
		AverageDemand: "Average Demand",
		StandardDeviation: "Standard Deviation",
		VariationCoefficient: "Variation Coefficient",
		Deviation: "Deviation",
		GeneralConfig: "General Configuration",
		DetailedConfig: "Detailed Configuration",
		ClustersCreated: "Clusters Created",
		MicroClusters: "Micro Clusters",
		MicroClustersPerCluster: "Micro Clusters per Cluster",
		Total: "Total",
		GeneratingConfig: "Generating Configuration",
		EnableCapacities: "Enable Capacities",
		Enabled: "Enabled",
		Disabled: "Disabled",
		ExpandAll: "Expand All",
		CollapseAll: "Collapse All",
		Of: "of",
		Balance: {
			Excellent: "Excellent",
			Good: "Good",
			Fair: "Fair",
			Poor: "Poor",
		},
		MapLoadError: "Google Maps could not be loaded. Please reload the page.",
		NoStatsAvailable: "No statistics available",
		ExportToExcel: "Export to Excel",
		ExportedSuccessfully: "Statistics exported successfully",
		ExportError: "Error exporting statistics",
		NoDataToExport: "No data to export",
		ExportingData: "Preparing export...",
		ViewingOnMap: "Displaying clustering on map",
		OpeningList: "Opening clustering list",
		ZoomTo: "Zoom To",
		FocusOn: "Focus On",
		RemoveFocus: "Remove Focus",
		FocusedOn: "Focused on",
		Showing: "Showing",
		ShowingAll: "Showing all clusters",
		Highlight: "Highlight",
		Highlighted: "Highlighted",
		ShowAll: "Show All",
		Points: "Points",
		EnableHeatmap: "Enable Heatmap",
		DisableHeatmap: "Disable Heatmap",
		HeatmapEnabled: "Demand heatmap enabled",
		HeatmapDisabled: "Demand heatmap disabled",
		NoPointsInCluster: "No points found in this cluster",
		ZoomedToCluster: "Zoomed to cluster",
		Compactness: "Compactness",
		AvgRadius: "Average Radius",
		MaxDistance: "Max Distance",
		Area: "Area",
		Legend: "Legend",
		PointTypes: "Point Types",
		SelectedPoints: "Selected Points",
		UnselectedPoints: "Unselected Points",
		ClusteredPoints: "Clustered Points",
		Layers: "Layers",
		ClusterPolygons: "Cluster Polygons",
		Heatmap: "Heatmap",
		DemandIntensity: "Demand Intensity",
		Demand: "Demand",
		Capacity: "Capacity",
		Usage: "Usage",
		NoStatsFound: "No statistics found",
		ShowingItems: "Showing {start}-{end} of {total}",
		Cluster: "Cluster",
		Clusters: "Clusters",
		MicroCluster: "Micro Cluster",
		SearchClusters: "Search clusters...",
		NoClustersFound: "No clusters found",

		// View Mode
		ViewMode: "View Mode",
		ViewClusters: "Clusters",
		ViewMicroClusters: "Micro Clusters",
		ViewStatistics: "View Statistics",
		ViewModeChanged: "View mode changed",
		GroupedView: "Grouped View",
		DetailedView: "Detailed View",
		ViewClustersTooltip: "View grouped clusters with their micro-clusters",
		ViewMicroClustersTooltip: "View each micro-cluster individually",
		ViewOnMap: "View on map",
		ViewClustersOnMap: "View clusters on map",
		ViewMicroClustersOnMap: "View micro clusters on map",
		ConfirmViewModeChange: "Confirm Mode Change",
		ViewModeChangeWarning:
			"Changing the view mode will clear the map and close all windows. Do you want to continue?",
		ViewModeChangedSuccessfully: "View mode changed successfully",
		CreatingCluster: "Creating Cluster",
		Processing: "Processing",
		CreatingClusterMessageBackground:
			"We are creating your cluster in the background. This may take a few moments. While you wait, you can continue using the platform normally.",
		// Points
		LoadedPoints: "Loaded Points",
		LoadPoints: "Load Points",
		LoadAllPoints: "Load All Points",
		ManagePoints: "Manage Points",
		NoPointsLoaded: "No points loaded. Use 'Manage Points' or 'Load All Points' to start.",
		TooManyPoints: "Too many points (max 500). Please filter or select fewer points.",
		PointsLoaded: {
			Title: "Points Loaded",
			Text: "points loaded successfully",
		},
		NoPointsFound: {
			Title: "No Points",
			Text: "No visit points available.",
		},
		ErrorLoadingPoints: "Error loading visit points",
		SearchPoints: "Search points...",
		PointAlreadyExists: "This point already exists in the list",

		// Clustering Creation
		CreateNew: "Create New Clustering",
		Name: "Clustering Name",
		NamePlaceholder: "Ex: Bogota Downtown - North Zone",
		NameRequired: "Clustering name is required",
		NameTooLong: "Name cannot exceed 125 characters",
		NameLength: "Characters",
		EditName: "Edit Clustering Name",
		Updated: "Clustering updated successfully",
		UpdateError: "Error updating clustering",
		FocusRemoved: "Focus removed successfully",
		TotalClusters: "Number of Clusters",
		Max10: "Max: 10",
		MicroClustersHelp: "Subdivisions within each cluster (optional)",
		Generate: "Generate Clustering",
		Generating: "Generating",
		GeneratedSuccess: "Clustering generated successfully!",
		Reset: "Reset",
		ViewList: "View List",

		// Demand Configuration
		DemandConfiguration: "Demand Configuration",
		DemandConfigHelp: "Configure demand (required capacity) for each visit point",
		QuickDemand: "Quick Demand",
		ApplyToAll: "Apply to All",
		QuickDemandApplied: "Quick demand applied to all points",
		EditDemands: "Edit Individually",

		// Manual Selection & Point Selection
		ManualSelection: "Manual Selection",
		ManualSelectionHelp: "Draw a polygon on the map to select specific points",
		SelectionTools: "Selection Tools",
		SelectionToolsHelp: "Select points using multiple methods",
		StartSelection: "Start Selection",
		CreateWithSelection: "Create with Selection",
		DrawPolygonHelp: "Draw multiple polygons. Each polygon will add points to the selection.",
		DrawPolygons: "Draw Polygons",
		FinishDrawing: "Finish Drawing",
		UndoLast: "Undo Last",
		ClearAll: "Clear All",
		RemoveLastPolygon: "Remove Last",
		ClearPolygons: "Clear Polygons",
		Polygons: "Polygons",
		SelectPoints: "Select Points",
		AvailablePoints: "Available Points",
		Available: "Available",
		Selected: "Selected",
		ClearSelection: "Clear Selection",
		ClearMap: "Clear Map",
		MapCleared: "Map cleared successfully",
		SelectPointsToStart: "Select points to start (polygon, click, or complete selection)",
		QuickSelection: "Quick Selection",
		SelectAll: "Select All",
		DeselectAll: "Deselect All",
		ClickPointsHelp: "Click on gray points to add them or green points to remove them",
		ViewSelected: "View Selected",
		NoPointsSelected: "No points selected. Draw a polygon on the map first.",
		PolygonMode: {
			Title: "Polygon Mode Activated",
			Text: "Draw multiple polygons to select points. Click 'Finish' when done.",
		},
		PolygonSelected: "Polygon Selected",
		PolygonSelectedHelp: "Double-click to remove or use red button",
		ConfirmRemovePolygon: "Remove this polygon? Points inside will be deselected.",
		DeletePolygon: "Delete Polygon",
		PolygonRemoved: "Polygon Removed",
		RemainingPolygons: "Remaining Polygons",
		PointsAdded: {
			Title: "Points Added",
			Text: "points added to selection",
		},
		PointAdded: {
			Title: "Point Added",
			Text: "added to selection",
		},
		PointRemoved: {
			Title: "Point Removed",
			Text: "Point removed from selection",
		},
		SelectionCleared: {
			Title: "Selection Cleared",
			Text: "All polygons and selection cleared",
		},
		AllSelected: {
			Title: "All Selected",
			Text: "points selected",
		},
		AllDeselected: {
			Title: "Selection Cleared",
			Text: "All points have been deselected",
		},

		// Messages
		Success: {
			Title: "Clustering Created",
			Text: "Clustering has been created successfully",
		},
		Deleted: {
			Title: "Clustering Deleted",
			Text: "Clustering has been deleted successfully",
		},
		ValidationError: "Please complete all required fields",
		PointsLimitExceeded: "You have exceeded the limit of 500 points",
		ErrorCreating: "Error creating clustering",
		ErrorLoadingList: "Error loading cluster list",
		ErrorDeleting: "Error deleting clustering",
		ErrorLoading: "Error loading clustering",
		ErrorDemandExceedsCapacity: "The total demand {totalDemand} exceeds the total capacity {totalCapacity}",
		SwitchedToClusters: "Switched to Clusters view",
		SwitchedToMicroClusters: "Switched to Micro-clusters view",
		Loaded: "Loaded",
		ConfirmReset: "Are you sure you want to reset the clustering? This will clear all data.",
		ConfirmDelete: "Are you sure you want to delete",
		DemandDistribution: "Demand Distribution",
	},
};
